// Wahup custom shirt popup cart flow with Design Mode layers build 20260618034500
(function () {
  var lockedScrollY = 0;
  var scrollLockActive = false;

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function apiBase(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    return endpoint.replace(/\/popup\/?(?:\?.*)?$/, '/');
  }

  function blogPostImageUrl(root) {
    var value = root && root.getAttribute ? String(root.getAttribute('data-blog-post-image-url') || '').trim() : '';
    if (!value) return '';
    try {
      return new URL(value, window.location.href).href;
    } catch (error) {
      return value;
    }
  }

  function buildUrl(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('shop', root.getAttribute('data-shop') || '');
    url.searchParams.set('path', root.getAttribute('data-path') || window.location.pathname);
    if (root.getAttribute('data-template-id')) url.searchParams.set('template_id', root.getAttribute('data-template-id'));
    url.searchParams.set('_ts', String(Date.now()));
    return url.toString();
  }

  function trackingContext(root, extra) {
    var context = {
      component: root && root.matches && root.matches('[data-wahup-custom-shirt-inline-root]') ? 'custom_shirt_product_page' : 'custom_shirt_popup',
      shop: root && root.getAttribute ? (root.getAttribute('data-shop') || '') : '',
      product_id: root && root.getAttribute ? (root.getAttribute('data-product-id') || '') : '',
      product_handle: root && root.getAttribute ? (root.getAttribute('data-product-handle') || '') : '',
      page_path: root && root.getAttribute ? (root.getAttribute('data-path') || window.location.pathname) : window.location.pathname,
      page_location: window.location.href
    };
    if (root && root.__wahupActiveTemplate) {
      Object.assign(context, templateTracking(root.__wahupActiveTemplate));
    }
    if (root && root.__wahupActiveMockup) {
      Object.assign(context, mockupTracking(root.__wahupActiveMockup));
    }
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        var value = extra[key];
        if (value === undefined || value === null || value === '') return;
        context[key] = value;
      });
    }
    return context;
  }

  function trackEvent(root, name, params) {
    if (!name) return;
    var payload = trackingContext(root, params);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event:name }, payload));
      }
    } catch (error) {}
  }

  function templateTracking(template) {
    if (!template) return {};
    return {
      template_id: template.id,
      template_name: template.name,
      template_slug: template.slug,
      product_type: template.product_type
    };
  }

  function mockupTracking(mockup) {
    if (!mockup) return {};
    return {
      mockup_id: mockup.id,
      color_name: mockup.color_name,
      color_code: mockup.color_code,
      color_hex: mockup.color_hex,
      is_default_color: !!mockup.is_default
    };
  }

  function inputTracking(input) {
    if (!input || !input.getAttribute) return {};
    return {
      field_type: input.getAttribute('data-layer-id') ? 'layer_text' : 'slot_text',
      slot_id: input.getAttribute('data-slot-id') || '',
      layer_id: input.getAttribute('data-layer-id') || '',
      slot_label: input.getAttribute('data-slot-label') || '',
      text_length: String(input.value || '').length
    };
  }

  function openPopup(root, source) {
    var launcher = root && root.__wahupLauncher;
    if (launcher) {
      launcher.classList.remove('is-shaking');
      launcher.hidden = true;
    }
    root.hidden = false;
    root.classList.remove('is-collapsed', 'is-collapsing');
    root.classList.add('is-expanding');
    root.__wahupLayerAnimationPlayed = false;
    if (!scrollLockActive) {
      lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      scrollLockActive = true;
    }
    document.documentElement.classList.add('wahup-custom-shirt-popup-open');
    window.clearTimeout(root.__wahupExpandTimer);
    root.__wahupExpandTimer = window.setTimeout(function () { root.classList.remove('is-expanding'); }, 420);
    var refresh = function () {
      if (root && typeof root.__wahupCustomShirtRefresh === 'function') root.__wahupCustomShirtRefresh();
    };
    window.requestAnimationFrame(function () { window.requestAnimationFrame(refresh); });
    if (root && !root.__wahupOpenTracked) {
      root.__wahupOpenTracked = true;
      trackEvent(root, 'custom_shirt_open', { source:source || 'auto' });
    } else {
      trackEvent(root, 'custom_shirt_reopen', { source:source || 'auto' });
    }
  }

  function closePopup(root, reason) {
    if (root && typeof root.__wahupMobileTextEditorClose === 'function') root.__wahupMobileTextEditorClose();
    root.classList.remove('is-expanding');
    root.classList.add('is-collapsing');
    document.documentElement.classList.remove('wahup-custom-shirt-popup-open');
    if (scrollLockActive) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
      scrollLockActive = false;
    }
    window.clearTimeout(root.__wahupCollapseTimer);
    root.__wahupCollapseTimer = window.setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-collapsing');
      root.classList.add('is-collapsed');
      if (root.__wahupLauncher) root.__wahupLauncher.hidden = false;
    }, 290);
    trackEvent(root, 'custom_shirt_close', { reason:reason || 'close_button' });
  }

  function ensureLauncher(root) {
    if (!root) return null;
    if (root.__wahupLauncher) return root.__wahupLauncher;
    var launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'wahup-custom-shirt-launcher';
    launcher.setAttribute('aria-label', 'Open custom shirt builder');
    launcher.innerHTML = '<span aria-hidden="true">👕</span><span class="wahup-custom-shirt-launcher__badge" aria-hidden="true">!</span>';
    launcher.addEventListener('click', function () {
      trackEvent(root, 'custom_shirt_launcher_click');
      openPopup(root, 'launcher');
    });
    document.body.appendChild(launcher);
    root.__wahupLauncher = launcher;
    return launcher;
  }

  function shakeLauncherBeforeOpen(root, callback) {
    var launcher = ensureLauncher(root);
    if (!launcher) {
      callback();
      return;
    }
    launcher.hidden = false;
    launcher.classList.remove('is-shaking');
    void launcher.offsetWidth;
    launcher.classList.add('is-shaking');
    window.setTimeout(function () {
      launcher.classList.remove('is-shaking');
      callback();
    }, 760);
  }

  function fallbackHtml() {
    return '<div class="wahup-custom-shirt-content"><p class="wahup-custom-shirt-eyebrow">Make Your Own T-Shirt</p><h2 id="wahup-custom-shirt-popup-title">Make Your Own T-Shirt</h2><p class="wahup-custom-shirt-copy">The custom shirt builder is loading. Please try again in a moment.</p></div>';
  }

  function loadingHtml() {
    return '<div class="wahup-custom-shirt-content"><p class="wahup-custom-shirt-eyebrow">Make Your Own T-Shirt</p><h2 id="wahup-custom-shirt-popup-title">Make Your Own T-Shirt</h2><p class="wahup-custom-shirt-copy">Loading custom shirt builder...</p></div>';
  }

  function fetchPopupPayload(root, options) {
    options = options || {};
    var attempts = Math.max(1, options.attempts || 3);
    var timeoutMs = Math.max(2500, options.timeoutMs || 8000);
    var attempt = 0;
    function run() {
      attempt += 1;
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timeout = controller ? window.setTimeout(function () { controller.abort(); }, timeoutMs) : null;
      return fetch(buildUrl(root), { credentials: 'omit', mode: 'cors', cache: 'no-store', signal: controller ? controller.signal : undefined })
        .then(function (response) {
          if (timeout) window.clearTimeout(timeout);
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .catch(function (error) {
          if (timeout) window.clearTimeout(timeout);
          if (attempt >= attempts) throw error;
          return new Promise(function (resolve) {
            window.setTimeout(resolve, 450 * attempt);
          }).then(run);
        });
    }
    return run();
  }

  function afterPageSettled(callback) {
    var run = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 2500 });
      else window.setTimeout(callback, 250);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function transformText(value, mode) {
    var text = String(value || '');
    if (mode === 'uppercase') return text.toUpperCase();
    if (mode === 'lowercase') return text.toLowerCase();
    if (mode === 'titlecase') return text.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    return text;
  }

  var loadedFonts = {};
  function cssFontName(name) {
    return 'WahupDesignFont_' + String(name || '').replace(/[^a-z0-9_-]/gi, '_');
  }

  function fontStack(name) {
    if (!name || name === 'Arial') return 'Arial, sans-serif';
    return '"' + cssFontName(name) + '", "' + String(name).replace(/"/g, '\\"') + '", Arial, sans-serif';
  }

  function findDesignFont(name) {
    var wanted = String(name || '').trim().toLowerCase();
    if (!wanted) return null;
    return (window.__wahupDesignFonts || []).find(function (font) {
      return String(font.name || '').trim().toLowerCase() === wanted ||
        String(font.css_family || '').trim().toLowerCase() === wanted;
    }) || null;
  }

  function toNum(value, fallback) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function colorFontInfo(fontName) {
    var font = findDesignFont(fontName);
    if (!font || String(font.kind || font.type || '').toLowerCase() !== 'color' || !Array.isArray(font.glyphs) || !font.glyphs.length) return null;
    var charMap = {};
    font.glyphs.forEach(function (glyph) {
      if (!glyph) return;
      var image = glyph.image || glyph.image_url || '';
      if (!image) return;
      glyph.image = image;
      if (glyph.char) charMap[glyph.char] = glyph;
      if (glyph.character) charMap[glyph.character] = glyph;
      if (typeof glyph.codepoint === 'number') {
        try { charMap[String.fromCodePoint(glyph.codepoint)] = glyph; } catch (error) {}
      }
    });
    return { font: font, glyphs: font.glyphs, charMap: charMap };
  }

  function colorFontGlyph(info, symbol) {
    if (!info || !symbol) return null;
    var glyph = info.charMap[symbol];
    if (glyph) return glyph;
    try {
      var codepoint = symbol.codePointAt(0);
      glyph = info.glyphs.find(function (item) { return item && item.codepoint === codepoint; }) || null;
      if (glyph) return glyph;
    } catch (error) {}
    if (symbol.length === 1) {
      glyph = info.charMap[symbol.toUpperCase()] || info.charMap[symbol.toLowerCase()] || null;
    }
    return glyph || null;
  }

  function createQuadraticSampler(p0, p1, p2) {
    return function (t) {
      var u = Math.max(0, Math.min(1, t || 0));
      var v = 1 - u;
      return {
        x: v * v * p0.x + 2 * v * u * p1.x + u * u * p2.x,
        y: v * v * p0.y + 2 * v * u * p1.y + u * u * p2.y,
        dx: 2 * v * (p1.x - p0.x) + 2 * u * (p2.x - p1.x),
        dy: 2 * v * (p1.y - p0.y) + 2 * u * (p2.y - p1.y)
      };
    };
  }

  function createCubicSampler(p0, p1, p2, p3) {
    return function (t) {
      var u = Math.max(0, Math.min(1, t || 0));
      var v = 1 - u;
      return {
        x: v * v * v * p0.x + 3 * v * v * u * p1.x + 3 * v * u * u * p2.x + u * u * u * p3.x,
        y: v * v * v * p0.y + 3 * v * v * u * p1.y + 3 * v * u * u * p2.y + u * u * u * p3.y,
        dx: 3 * v * v * (p1.x - p0.x) + 6 * v * u * (p2.x - p1.x) + 3 * u * u * (p3.x - p2.x),
        dy: 3 * v * v * (p1.y - p0.y) + 6 * v * u * (p2.y - p1.y) + 3 * u * u * (p3.y - p2.y)
      };
    };
  }

  function createSemiCircleSampler(radius, orientation) {
    return function (t) {
      var u = Math.max(0, Math.min(1, t || 0));
      var dir = orientation === 'down' ? 1 : -1;
      var theta = Math.PI - Math.PI * u;
      return { x: radius * Math.cos(theta), y: dir * radius * Math.sin(theta), dx: radius * Math.PI * Math.sin(theta), dy: dir * radius * Math.PI * Math.cos(theta) };
    };
  }

  function samplerLength(sampler) {
    var previous = sampler(0);
    var total = 0;
    for (var i = 1; i <= 80; i += 1) {
      var current = sampler(i / 80);
      total += Math.sqrt(Math.pow((current.x || 0) - (previous.x || 0), 2) + Math.pow((current.y || 0) - (previous.y || 0), 2));
      previous = current;
    }
    return total || 1;
  }

  function createSamplerLookup(sampler) {
    if (typeof sampler !== 'function') return null;
    var samples = [];
    var total = 0;
    var previous = sampler(0);
    samples.push({ t: 0, point: previous, length: 0 });
    for (var i = 1; i <= 120; i += 1) {
      var t = i / 120;
      var current = sampler(t);
      total += Math.sqrt(Math.pow((current.x || 0) - (previous.x || 0), 2) + Math.pow((current.y || 0) - (previous.y || 0), 2));
      samples.push({ t: t, point: current, length: total });
      previous = current;
    }
    if (!Number.isFinite(total) || total <= 0) total = 1;
    return {
      total: total,
      sample: function (distance) {
        var target = clamp(distance, 0, total);
        for (var index = 1; index < samples.length; index += 1) {
          if (samples[index].length >= target) {
            var lower = samples[index - 1];
            var upper = samples[index];
            var span = upper.length - lower.length || 1;
            var alpha = (target - lower.length) / span;
            var sampleT = lower.t + (upper.t - lower.t) * alpha;
            return sampler(sampleT);
          }
        }
        return samples[samples.length - 1].point;
      }
    };
  }

  function textPathSampler(pathId, strength) {
    var s = clamp(toNum(strength, 1), 0.3, pathId === 'wave' ? 2 : 1.8);
    function withMeta(lookup) {
      if (lookup) {
        lookup.pathId = pathId || 'none';
        lookup.strength = s;
      }
      return lookup;
    }
    if (pathId === 'arc-up' || pathId === 'arc-down') {
      var span = 260;
      var amp = 220 * s * (pathId === 'arc-up' ? -1 : 1);
      return withMeta(createSamplerLookup(createQuadraticSampler({ x: -span, y: 0 }, { x: 0, y: amp }, { x: span, y: 0 })));
    }
    if (pathId === 'wave') {
      var amplitude = 80 * s;
      var first = createCubicSampler({ x: -300, y: 0 }, { x: -200, y: -amplitude }, { x: -100, y: amplitude }, { x: 0, y: 0 });
      var second = createCubicSampler({ x: 0, y: 0 }, { x: 100, y: -amplitude }, { x: 200, y: amplitude }, { x: 300, y: 0 });
      var firstLength = samplerLength(first);
      var secondLength = samplerLength(second);
      var total = firstLength + secondLength;
      return withMeta(createSamplerLookup(function (t) {
        var distance = clamp(t, 0, 1) * total;
        if (distance <= firstLength) return first(distance / firstLength);
        return second((distance - firstLength) / secondLength);
      }));
    }
    if (pathId === 'circle') return withMeta(createSamplerLookup(createSemiCircleSampler(220 * clamp(toNum(strength, 1), 0.5, 1.5))));
    return null;
  }

  function layoutGlyphs(textValue, info, fontSizePx, letterSpacing) {
    var fontSize = Math.max(8, toNum(fontSizePx, 72));
    var spacing = Math.max(0, toNum(letterSpacing, Math.max(fontSize * 0.05, 4)));
    var lineHeight = fontSize * 1.2;
    var lines = String(textValue || '').split(/\r?\n/);
    var rows = [];
    var maxWidth = 0;
    lines.forEach(function (line, lineIndex) {
      var items = [];
      var cursor = 0;
      String(line || ' ').split('').forEach(function (symbol) {
        var glyph = symbol === ' ' ? null : colorFontGlyph(info, symbol);
        var baseWidth = glyph ? (toNum(glyph.width, fontSize) || fontSize) : Math.max(fontSize * 0.35, 12);
        var baseHeight = glyph ? (toNum(glyph.height, fontSize) || fontSize) : fontSize;
        var width = glyph ? fontSize * baseWidth / Math.max(1, baseHeight) : Math.max(fontSize * 0.35, 12);
        var height = glyph ? fontSize : fontSize;
        items.push({ symbol: symbol, glyph: glyph, x: cursor, y: lineIndex * lineHeight, width: width, height: height });
        cursor += width + spacing;
      });
      if (cursor > 0) cursor -= spacing;
      maxWidth = Math.max(maxWidth, cursor);
      rows.push({ items: items, width: Math.max(cursor, 1) });
    });
    return { rows: rows, width: Math.max(maxWidth, fontSize, 2), height: Math.max(lines.length * lineHeight, fontSize), spacing: spacing, lineHeight: lineHeight };
  }

  function layoutColorFontTextOnPath(layout, lookup) {
    if (!layout || !lookup || typeof lookup.sample !== 'function') return null;
    var instructions = Array.isArray(layout.instructions) ? layout.instructions.slice() : [];
    if (!instructions.length) return null;
    var totalLength = toNum(lookup.total, 0);
    if (!isFinite(totalLength) || totalLength <= 0) return null;
    var pathId = String(layout.textPath || lookup.pathId || '');
    var pathStrength = toNum(layout.textPathStrength != null ? layout.textPathStrength : lookup.strength, 1);
    var isArcPath = pathId === 'arc-up' || pathId === 'arc-down';
    function samplePoint(distance) {
      return lookup.sample(clamp(distance, 0, totalLength)) || { x: 0, y: 0, dx: 0, dy: -1 };
    }
    var fontSize = Math.max(8, toNum(layout.fontSize, 72));
    var tangentDelta = Math.max(totalLength * 0.006, fontSize * 0.08, 2);
    function sampleTangent(distance) {
      var sampled = samplePoint(distance);
      if (sampled && (sampled.dx || sampled.dy)) return { x: sampled.dx || 0, y: sampled.dy || 0 };
      var a = samplePoint(Math.max(distance - tangentDelta, 0));
      var b = samplePoint(Math.min(distance + tangentDelta, totalLength));
      return { x: (b.x || 0) - (a.x || 0), y: (b.y || 0) - (a.y || 0) };
    }
    var spacing = Math.max(0, toNum(layout.letterSpacing, 0));
    var totalWidth = isFinite(layout.totalWidth) ? layout.totalWidth : instructions.reduce(function (sum, item) {
      return sum + Math.max(0, toNum(item && item.width, 0));
    }, 0) + spacing * Math.max(instructions.length - 1, 0);
    if (!isFinite(totalWidth) || totalWidth === 0) totalWidth = 1;
    if (totalWidth < 0) totalWidth = Math.abs(totalWidth);
    var edgePadding = isArcPath
      ? Math.min(totalLength * 0.18, Math.max(fontSize * 0.75, 24))
      : Math.min(totalLength * 0.12, Math.max(fontSize * 0.55, 18));
    var minDistance = Math.min(edgePadding, totalLength / 2);
    var maxDistance = Math.max(minDistance, totalLength - edgePadding);
    var usableLength = Math.max(1, maxDistance - minDistance);
    var scaleFactor = 1;
    var startOffset = minDistance + Math.max(0, (usableLength - totalWidth) / 2);
    if (totalWidth > usableLength) {
      scaleFactor = Math.min(1, usableLength / totalWidth);
      startOffset = minDistance + Math.max(0, (usableLength - totalWidth * scaleFactor) / 2);
    }
    var cumulative = 0;
    var glyphCount = instructions.length;
    return instructions.map(function (inst, index) {
      var glyphWidth = isFinite(inst && inst.width) ? inst.width : 0;
      if (glyphWidth <= 0) glyphWidth = Math.max((layout.fontSize || 72) * 0.6, spacing || 12);
      var distance = startOffset + (cumulative + glyphWidth / 2) * scaleFactor;
      if (!isFinite(distance)) distance = totalLength * ((index + 0.5) / glyphCount);
      distance = clamp(distance, minDistance, maxDistance);
      var point = samplePoint(distance);
      var tangent = sampleTangent(distance);
      var angle = 0;
      var normalX = 0;
      var normalY = -1;
      if (tangent && (tangent.x || tangent.y)) {
        angle = Math.atan2(tangent.y, tangent.x) * 180 / Math.PI;
        if (isArcPath) {
          var maxArcAngle = clamp(30 + Math.max(0, pathStrength - 1) * 16, 30, 42);
          angle = clamp(angle, -maxArcAngle, maxArcAngle);
        }
        var len = Math.sqrt(tangent.x * tangent.x + tangent.y * tangent.y);
        if (len) {
          normalX = -tangent.y / len;
          normalY = tangent.x / len;
        }
      }
      var glyphHeight = isFinite(inst && inst.height) ? inst.height : (layout.fontSize || 0);
      var baselineOffset = (glyphHeight || 0) / 2;
      cumulative += glyphWidth;
      if (index < instructions.length - 1) cumulative += spacing;
      return {
        item: inst,
        x: (point.x || 0) + normalX * -baselineOffset,
        y: (point.y || 0) + normalY * -baselineOffset,
        angle: angle
      };
    });
  }

  function colorFontPathBounds(placements) {
    if (!Array.isArray(placements) || !placements.length) return null;
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    placements.forEach(function (placement) {
      var item = placement.item || {};
      var width = Math.max(1, toNum(item.width, 1));
      var height = Math.max(1, toNum(item.height, width));
      var angle = toNum(placement.angle, 0) * Math.PI / 180;
      var cos = Math.abs(Math.cos(angle));
      var sin = Math.abs(Math.sin(angle));
      var extentX = cos * width / 2 + sin * height / 2;
      var extentY = sin * width / 2 + cos * height / 2;
      minX = Math.min(minX, toNum(placement.x, 0) - extentX);
      maxX = Math.max(maxX, toNum(placement.x, 0) + extentX);
      minY = Math.min(minY, toNum(placement.y, 0) - extentY);
      maxY = Math.max(maxY, toNum(placement.y, 0) + extentY);
    });
    if (![minX, minY, maxX, maxY].every(isFinite)) return null;
    return { minX: minX, minY: minY, maxX: maxX, maxY: maxY, width: Math.max(1, maxX - minX), height: Math.max(1, maxY - minY) };
  }

  function pathPlacementBounds(lookup, items, totalWidth, letterSpacing) {
    if (!lookup || !Array.isArray(items) || !items.length) return null;
    var layout = {
      instructions: items,
      letterSpacing: Math.max(0, toNum(letterSpacing, 0)),
      totalWidth: Math.max(1, toNum(totalWidth, 1)),
      fontSize: items.reduce(function (max, item) { return Math.max(max, toNum(item && item.height, 0)); }, 0) || 72
    };
    return colorFontPathBounds(layoutColorFontTextOnPath(layout, lookup));
  }

  function colorFontPathPadding(fontSizePx) {
    var size = Math.max(8, toNum(fontSizePx, 72));
    return Math.max(size * 0.75, 32);
  }

  function layoutNormalTextPath(layer, text, fontSizePx) {
    var fontSize = Math.max(8, toNum(fontSizePx, 72));
    var spacing = Math.max(0, toNum(layer.letterSpacing || layer.letter_spacing, 0));
    var measure = document.createElement('canvas').getContext('2d');
    if (measure) measure.font = fontSize + 'px ' + fontStack(layer.fontFamily || 'Arial');
    var instructions = Array.from(String(text || 'Text').replace(/\s+/g, ' ')).map(function (symbol) {
      var measured = measure ? measure.measureText(symbol).width : 0;
      var width = symbol === ' ' ? Math.max(fontSize * 0.35, 8) : Math.max(measured || fontSize * 0.62, fontSize * 0.35, 8);
      return { symbol: symbol, width: width, height: fontSize };
    });
    var totalWidth = instructions.reduce(function (sum, item) { return sum + item.width; }, 0) + spacing * Math.max(0, instructions.length - 1);
    return { instructions: instructions, totalWidth: Math.max(1, totalWidth), letterSpacing: spacing, fontSize: fontSize };
  }

  function renderColorFontLayer(layer, text, fontSizePx, layoutScale) {
    var info = colorFontInfo(layer.fontFamily);
    if (!info) return null;
    var root = document.createElement('div');
    root.className = 'wahup-custom-shirt-color-text';
    root.dataset.colorFontText = layer.fontFamily || '';
    var spacing = Math.max(0, toNum(layer.letterSpacing, 0));
    var path = layer.textPath && layer.textPath !== 'none' ? textPathSampler(layer.textPath, layer.textPathStrength) : null;
    var pathLayoutScale = Math.max(0.01, toNum(layoutScale, 1));
    var layoutFontSizePx = path ? fontSizePx * pathLayoutScale : fontSizePx;
    var displayRatio = path ? fontSizePx / Math.max(1, layoutFontSizePx) : 1;
    var layout = layoutGlyphs(String(text || ''), info, layoutFontSizePx, spacing);
    if (path) {
      root.classList.add('is-path');
      var flat = [];
      layout.rows.forEach(function (row) { row.items.forEach(function (item) { flat.push(item); }); });
      var totalWidth = flat.reduce(function (sum, item) { return sum + item.width; }, 0) + spacing * Math.max(flat.length - 1, 0);
      var pathLayout = { instructions: flat, letterSpacing: spacing, totalWidth: totalWidth, fontSize: fontSizePx };
      var placements = layoutColorFontTextOnPath(pathLayout, path) || [];
      var bounds = pathPlacementBounds(path, flat, totalWidth, spacing) || colorFontPathBounds(placements);
      if (!bounds) return root;
      var pad = colorFontPathPadding(layoutFontSizePx);
      var viewWidth = Math.max(1, bounds.width + pad * 2);
      var viewHeight = Math.max(1, bounds.height + pad * 2);
      placements.forEach(function (placement) {
        var node = placement.item.glyph && placement.item.glyph.image ? document.createElement('img') : document.createElement('span');
        if (placement.item.glyph && placement.item.glyph.image) {
          node.src = placement.item.glyph.image;
          node.alt = placement.item.symbol;
        } else {
          node.textContent = placement.item.symbol;
          node.style.color = layer.color || '#111111';
          node.style.fontFamily = 'Arial, sans-serif';
        }
        node.style.position = 'absolute';
        node.style.left = (((placement.x - bounds.minX + pad) / viewWidth) * 100) + '%';
        node.style.top = (((placement.y - bounds.minY + pad) / viewHeight) * 100) + '%';
        node.style.width = (placement.item.width * displayRatio) + 'px';
        node.style.height = (placement.item.height * displayRatio) + 'px';
        node.style.transform = 'translate(-50%, -50%) rotate(' + placement.angle + 'deg)';
        root.appendChild(node);
      });
      return root;
    }
    layout.rows.forEach(function (row) {
      var line = document.createElement('div');
      line.className = 'wahup-custom-shirt-color-text-line';
      line.style.gap = spacing + 'px';
      line.style.justifyContent = layer.align === 'left' ? 'flex-start' : layer.align === 'right' ? 'flex-end' : 'center';
      row.items.forEach(function (item) {
        var node = item.glyph && item.glyph.image ? document.createElement('img') : document.createElement('span');
        if (item.glyph && item.glyph.image) {
          node.src = item.glyph.image;
          node.alt = item.symbol;
          node.style.width = item.width + 'px';
          node.style.height = item.height + 'px';
        } else {
          node.textContent = item.symbol;
          node.style.color = layer.color || '#111111';
          node.style.fontFamily = 'Arial, sans-serif';
          node.style.minWidth = item.width + 'px';
          node.style.height = item.height + 'px';
        }
        line.appendChild(node);
      });
      root.appendChild(line);
    });
    return root;
  }

  function ensureFont(fontOrSlot) {
    var font = fontOrSlot && fontOrSlot.default_font ? fontOrSlot.default_font : fontOrSlot;
    if (!font || !font.font_url) return font ? (font.name || font.css_family) : '';
    var sourceName = font.name || font.css_family;
    var family = cssFontName(sourceName);
    if (!loadedFonts[family]) {
      loadedFonts[family] = true;
      var style = document.createElement('style');
      var fontUrl = String(font.font_url);
      fontUrl += (fontUrl.indexOf('?') === -1 ? '?' : '&') + 'wahup_font_cors=' + encodeURIComponent(String(font.id || family));
      style.textContent = '@font-face{font-family:"' + family.replace(/"/g, '') + '";src:url("' + fontUrl.replace(/"/g, '%22') + '") format("opentype");font-display:swap;}';
      document.head.appendChild(style);
    }
    return sourceName;
  }

  function inputSelectorForField(field) {
    if (field.field_type === 'image_layer') return '[data-image-layer-id="' + cssEscape(String(field.layer_id)) + '"]';
    if (field.field_type === 'layer') return '[data-layer-id="' + cssEscape(String(field.layer_id)) + '"]';
    return '[name="slot_' + cssEscape(String(field.id)) + '"]';
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function collectFieldValues(form) {
    var values = {};
    if (!form) return values;
    form.querySelectorAll('[data-layer-id], [data-image-layer-id], [name^="slot_"]').forEach(function (input) {
      var key = input.getAttribute('data-image-layer-id') ? 'image:' + input.getAttribute('data-image-layer-id') : input.getAttribute('data-layer-id') ? 'layer:' + input.getAttribute('data-layer-id') : 'slot:' + String(input.name || '').replace(/^slot_/, '');
      values[key] = input.value || '';
    });
    return values;
  }

  function valueForField(field, existingValues) {
    var key = field.field_type === 'image_layer' ? 'image:' + field.layer_id : field.field_type === 'layer' ? 'layer:' + field.layer_id : 'slot:' + field.id;
    if (existingValues && Object.prototype.hasOwnProperty.call(existingValues, key)) return existingValues[key];
    if (field.field_type === 'image_layer') return field.default_image || '';
    return field.default_text || field.default_image || field.placeholder || '';
  }

  function designPayload(template, mockup) {
    var region = (mockup && mockup.design_region) || (template && template.design_region) || {};
    var design = region && region.design && Array.isArray(region.design.layers) ? region.design : null;
    if (!design && template && template.design_region && template.design_region.design && Array.isArray(template.design_region.design.layers)) design = template.design_region.design;
    return design || null;
  }

  function designRegion(template, mockup) {
    var source = (mockup && mockup.design_region) || (template && template.design_region) || {};
    var fallback = (template && template.design_region) || {};
    function number(value, defaultValue) {
      var parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : defaultValue;
    }
    var region = {
      x: number(source.x, number(fallback.x, 30)),
      y: number(source.y, number(fallback.y, 28)),
      width: number(source.width, number(fallback.width, 40)),
      height: number(source.height, number(fallback.height, 28)),
      rotation: number(source.rotation, number(fallback.rotation, 0))
    };
    if (region.x <= 1 && region.y <= 1 && region.width <= 1 && region.height <= 1) {
      region.x *= 100; region.y *= 100; region.width *= 100; region.height *= 100;
    }
    return region;
  }

  function positionLayerHost(layerHost, image, region) {
    var parent = image && image.parentElement;
    var parentRect = parent ? parent.getBoundingClientRect() : null;
    var imageRect = image ? image.getBoundingClientRect() : null;
    var parentWidth = parentRect && parentRect.width ? parentRect.width : 0;
    var parentHeight = parentRect && parentRect.height ? parentRect.height : 0;
    var naturalWidth = image && image.naturalWidth ? image.naturalWidth : 0;
    var naturalHeight = image && image.naturalHeight ? image.naturalHeight : 0;
    var imageWidth = imageRect && imageRect.width ? imageRect.width : parentWidth;
    var imageHeight = imageRect && imageRect.height ? imageRect.height : parentHeight;
    var contentLeft = imageRect && parentRect ? imageRect.left - parentRect.left : 0;
    var contentTop = imageRect && parentRect ? imageRect.top - parentRect.top : 0;
    var contentWidth = imageWidth;
    var contentHeight = imageHeight;
    if (naturalWidth && naturalHeight && imageWidth && imageHeight) {
      var scale = Math.min(imageWidth / naturalWidth, imageHeight / naturalHeight);
      contentWidth = naturalWidth * scale;
      contentHeight = naturalHeight * scale;
      contentLeft += (imageWidth - contentWidth) / 2;
      contentTop += (imageHeight - contentHeight) / 2;
    }
    if (!parentWidth || !parentHeight || !contentWidth || !contentHeight) {
      layerHost.style.inset = 'auto';
      layerHost.style.left = region.x + '%';
      layerHost.style.top = region.y + '%';
      layerHost.style.width = region.width + '%';
      layerHost.style.height = region.height + '%';
    } else {
      layerHost.style.inset = 'auto';
      layerHost.style.left = ((contentLeft + contentWidth * region.x / 100) / parentWidth * 100) + '%';
      layerHost.style.top = ((contentTop + contentHeight * region.y / 100) / parentHeight * 100) + '%';
      layerHost.style.width = (contentWidth * region.width / 100 / parentWidth * 100) + '%';
      layerHost.style.height = (contentHeight * region.height / 100 / parentHeight * 100) + '%';
    }
    layerHost.style.transformOrigin = '50% 50%';
    layerHost.style.transform = 'rotate(' + region.rotation + 'deg)';
  }

  function ensurePreviewStage(root) {
    var preview = root && root.querySelector('.wahup-custom-shirt-preview');
    if (!preview) return null;
    var stage = preview.querySelector('.wahup-custom-shirt-preview-stage');
    var image = preview.querySelector('[data-preview-mockup], [data-inline-preview-image]');
    var slots = preview.querySelector('[data-preview-slots], [data-inline-preview-slots]');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'wahup-custom-shirt-preview-stage';
      preview.insertBefore(stage, preview.firstChild);
    }
    if (image && image.parentNode !== stage) stage.appendChild(image);
    if (slots && slots.parentNode !== stage) stage.appendChild(slots);
    return stage;
  }

  function applyPreviewZoom(root) {
    var stage = root && root.querySelector('.wahup-custom-shirt-preview-stage');
    var state = root && root.__wahupPreviewZoom;
    if (!stage || !state || !state.active) {
      if (stage) stage.style.transform = '';
      return;
    }
    stage.style.transform = 'translate(' + state.panX + 'px, ' + state.panY + 'px) scale(' + state.scale + ')';
  }

  function restorePreviewZoomState(root, zoomState) {
    var preview = root && root.querySelector('.wahup-custom-shirt-preview');
    if (!preview) return;
    var state = zoomState ? {
      active: !!zoomState.active,
      scale: zoomState.scale || 1,
      panX: zoomState.panX || 0,
      panY: zoomState.panY || 0
    } : { active: false, scale: 1, panX: 0, panY: 0 };
    root.__wahupPreviewZoom = state;
    preview.classList.toggle('is-zoomed', state.active);
    var button = preview.querySelector('[data-preview-zoom]');
    if (button) {
      var mobileEditorMode = root.classList.contains('has-mobile-text-editor');
      button.classList.toggle('is-active', state.active);
      button.setAttribute('aria-pressed', state.active ? 'true' : 'false');
      button.setAttribute('aria-label', state.active ? (mobileEditorMode ? 'Refocus mockup design area' : 'Exit mockup zoom') : 'Zoom mockup design area');
      button.innerHTML = state.active && !mobileEditorMode ? '×' : '⛶';
    }
    applyPreviewZoom(root);
  }

  function fitPreviewZoomToDesign(root) {
    var preview = root && root.querySelector('.wahup-custom-shirt-preview');
    var stage = ensurePreviewStage(root);
    var layerHost = root && root.querySelector('[data-preview-slots], [data-inline-preview-slots]');
    if (!preview || !stage || !layerHost) return;
    var state = root.__wahupPreviewZoom || { active: false, scale: 1, panX: 0, panY: 0 };
    root.__wahupPreviewZoom = state;
    var previousTransform = stage.style.transform;
    stage.style.transform = '';
    var previewRect = preview.getBoundingClientRect();
    var areaRect = layerHost.getBoundingClientRect();
    stage.style.transform = previousTransform;
    if (!previewRect.width || !previewRect.height || !areaRect.width || !areaRect.height) return;
    var targetScale = Math.min(previewRect.width * 0.88 / areaRect.width, previewRect.height * 0.88 / areaRect.height);
    var scale = Math.max(1, Math.min(6, targetScale));
    var originX = previewRect.left + previewRect.width / 2;
    var originY = previewRect.top + previewRect.height / 2;
    var areaCenterX = areaRect.left + areaRect.width / 2;
    var areaCenterY = areaRect.top + areaRect.height / 2;
    state.scale = scale;
    state.panX = originX - (originX + (areaCenterX - originX) * scale);
    state.panY = originY - (originY + (areaCenterY - originY) * scale);
    applyPreviewZoom(root);
  }

  function setPreviewZoom(root, active) {
    var preview = root && root.querySelector('.wahup-custom-shirt-preview');
    if (!preview) return;
    ensurePreviewStage(root);
    var state = root.__wahupPreviewZoom || { active: false, scale: 1, panX: 0, panY: 0 };
    state.active = !!active;
    state.dragging = false;
    root.__wahupPreviewZoom = state;
    preview.classList.toggle('is-zoomed', state.active);
    var button = preview.querySelector('[data-preview-zoom]');
    if (button) {
      var mobileEditorMode = root.classList.contains('has-mobile-text-editor');
      button.classList.toggle('is-active', state.active);
      button.setAttribute('aria-pressed', state.active ? 'true' : 'false');
      button.setAttribute('aria-label', state.active ? (mobileEditorMode ? 'Refocus mockup design area' : 'Exit mockup zoom') : 'Zoom mockup design area');
      button.innerHTML = state.active && !mobileEditorMode ? '×' : '⛶';
    }
    if (state.active) fitPreviewZoomToDesign(root);
    else applyPreviewZoom(root);
  }

  function ensurePreviewZoomControl(root) {
    var preview = root && root.querySelector('.wahup-custom-shirt-preview');
    if (!preview || preview.__wahupZoomBound) return;
    preview.__wahupZoomBound = true;
    ensurePreviewStage(root);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'wahup-custom-shirt-preview-zoom';
    button.setAttribute('data-preview-zoom', '1');
    button.setAttribute('aria-label', 'Zoom mockup design area');
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = '⛶';
    preview.appendChild(button);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var state = root.__wahupPreviewZoom || { active: false, scale: 1, panX: 0, panY: 0 };
      if (root.classList.contains('has-mobile-text-editor') && state.active) {
        fitPreviewZoomToDesign(root);
        trackEvent(root, 'custom_shirt_preview_zoom_refocus', { source:'zoom_button' });
        return;
      }
      var nextActive = !state.active;
      setPreviewZoom(root, nextActive);
      trackEvent(root, nextActive ? 'custom_shirt_preview_zoom_in' : 'custom_shirt_preview_zoom_out', { source:'zoom_button' });
    });
    preview.addEventListener('pointerdown', function (event) {
      var state = root.__wahupPreviewZoom;
      if (!state || !state.active || event.target.closest('[data-preview-zoom]')) return;
      state.dragging = true;
      state.dragStartX = event.clientX;
      state.dragStartY = event.clientY;
      state.startPanX = state.panX;
      state.startPanY = state.panY;
      try { preview.setPointerCapture(event.pointerId); } catch (error) {}
      event.preventDefault();
    });
    preview.addEventListener('pointermove', function (event) {
      var state = root.__wahupPreviewZoom;
      if (!state || !state.active || !state.dragging) return;
      state.panX = state.startPanX + event.clientX - state.dragStartX;
      state.panY = state.startPanY + event.clientY - state.dragStartY;
      applyPreviewZoom(root);
      event.preventDefault();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (eventName) {
      preview.addEventListener(eventName, function () {
        var state = root.__wahupPreviewZoom;
        if (state && state.dragging) {
          state.dragging = false;
          trackEvent(root, 'custom_shirt_preview_pan', {
            pan_x: Math.round(Number(state.panX || 0)),
            pan_y: Math.round(Number(state.panY || 0)),
            scale: Number(state.scale || 1)
          });
        } else if (state) state.dragging = false;
      });
    });
  }

  function editableFields(template, mockup, root) {
    var design = designPayload(template, mockup);
    if (design && Array.isArray(design.layers) && design.layers.some(function (layer) { return layer && layer.type !== 'tape-path'; })) {
      var textIndex = 0;
      var imageIndex = 0;
      return (design.layers || []).filter(function (layer) { return layer && layer.type !== 'tape-path'; }).map(function (layer) {
        if (layer.type === 'image') {
          imageIndex += 1;
          var blogImage = (layer.useBlogPostImage || layer.use_blog_post_image) ? blogPostImageUrl(root) : '';
          var sourceImage = blogImage || layer.src || '';
          return {
            field_type: 'image_layer',
            field_id: 'image_layer_' + layer.id,
            layer_id: layer.id,
            id: layer.id,
            label: layer.label || ('Photo ' + imageIndex),
            placeholder: 'Upload custom photo',
            default_image: blogImage,
            source_image: sourceImage,
            use_blog_post_image: !!blogImage
          };
        }
        textIndex += 1;
        return {
          field_type: 'layer',
          field_id: 'layer_' + layer.id,
          layer_id: layer.id,
          id: layer.id,
          label: layer.label || ('Text ' + textIndex),
          placeholder: layer.text || 'Custom text',
          default_text: layer.text || '',
          max_length: 60,
          text_transform: 'none'
        };
      });
    }
    if (template && Array.isArray(template.text_slots) && template.text_slots.length) {
      return template.text_slots.map(function (slot) { return Object.assign({ field_type: 'slot', field_id: 'slot_' + slot.id }, slot); });
    }
    return [];
  }

  function fieldText(field, form) {
    var input = form ? form.querySelector(inputSelectorForField(field)) : null;
    return transformText(input ? input.value : field.default_text || field.placeholder || field.label, field.text_transform);
  }

  function fieldImageValue(field, form, root) {
    var uploadedImages = root && root.__wahupUploadedImages;
    if (uploadedImages && uploadedImages[String(field.layer_id)]) return uploadedImages[String(field.layer_id)];
    var selector = inputSelectorForField(field);
    var input = form ? form.querySelector(selector) : null;
    if (!input && root) input = root.querySelector(selector);
    if (!input) input = document.querySelector(selector);
    return (input && input.value) || field.default_image || field.source_image || '';
  }

  function customCartProperties(previewUrl, texts, baseProperties, mockup) {
    var properties = Object.assign({}, baseProperties || {});
    if (mockup) {
      if (mockup.id && !properties._wahup_mockup_id) properties._wahup_mockup_id = String(mockup.id);
      if (mockup.color_name && !properties._wahup_mockup_color) properties._wahup_mockup_color = String(mockup.color_name);
      if ((mockup.image_url || mockup.image_source_url) && !properties._wahup_mockup_image) {
        properties._wahup_mockup_image = String(mockup.image_url || mockup.image_source_url);
      }
    }
    if (previewUrl) properties['Custom preview'] = previewUrl;
    var photoIndex = 0;
    (texts || []).forEach(function (item, index) {
      var label = String(item && item.label ? item.label : ('Text ' + (index + 1))).trim() || ('Text ' + (index + 1));
      var text = String(item && item.text ? item.text : '').trim();
      var imageUrl = String(item && (item.image_url || item.url || item.src) ? (item.image_url || item.url || item.src) : '').trim();
      if (imageUrl) {
        photoIndex += 1;
        properties[('Photo ' + photoIndex).slice(0, 240)] = imageUrl.slice(0, 240);
      }
      if (text) properties[label.slice(0, 240)] = text.slice(0, 240);
    });
    return properties;
  }

  function layerText(layer, fields, form) {
    var field = fields.find(function (item) { return item.field_type === 'layer' && String(item.layer_id) === String(layer.id); });
    return field ? fieldText(field, form) : (layer.text || 'Text');
  }

  function layerImageSource(layer, fields, form, root) {
    var field = fields.find(function (item) { return item.field_type === 'image_layer' && String(item.layer_id) === String(layer.id); });
    if (!field) return layer.src || '';
    var uploadedImages = root && root.__wahupUploadedImages;
    if (uploadedImages && uploadedImages[String(layer.id)]) return uploadedImages[String(layer.id)];
    var selector = inputSelectorForField(field);
    var input = form ? form.querySelector(selector) : null;
    if (!input && root) input = root.querySelector(selector);
    if (!input) input = document.querySelector(selector);
    return (input && input.value) || layer.src || '';
  }

  function renderTextPath(layer, text, fontSizePx) {
    var path = textPathSampler(layer.textPath, layer.textPathStrength);
    if (!path) return null;
    var root = document.createElement('div');
    root.className = 'wahup-custom-shirt-normal-text is-path';
    root.style.position = 'relative';
    root.style.width = '100%';
    root.style.height = '100%';
    root.style.overflow = 'visible';
    root.style.pointerEvents = 'none';
    var normalFont = findDesignFont(layer.fontFamily);
    if (normalFont) ensureFont(normalFont);
    var layout = layoutNormalTextPath(layer, text, fontSizePx);
    var placements = layoutColorFontTextOnPath(layout, path) || [];
    var bounds = pathPlacementBounds(path, layout.instructions, layout.totalWidth, layout.letterSpacing) || colorFontPathBounds(placements);
    if (!bounds) return root;
    var pad = colorFontPathPadding(fontSizePx);
    var viewWidth = Math.max(1, bounds.width + pad * 2);
    var viewHeight = Math.max(1, bounds.height + pad * 2);
    var pathStrokeScale = Math.max(0.001, Number(layer.__wahupViewportScale || (fontSizePx / Math.max(1, Number(layer.fontSize || fontSizePx || 1)))));
    var pathStrokeWidth = Math.max(0, Number(layer.strokeWidth || layer.stroke_width || 0) * pathStrokeScale);
    placements.forEach(function (placement) {
      var item = placement.item || {};
      var symbol = String(item.symbol || '');
      if (!symbol) return;
      var span = document.createElement('span');
      span.textContent = symbol === ' ' ? '\u00a0' : symbol;
      span.style.position = 'absolute';
      span.style.left = (((placement.x - bounds.minX + pad) / viewWidth) * 100) + '%';
      span.style.top = (((placement.y - bounds.minY + pad) / viewHeight) * 100) + '%';
      span.style.transform = 'translate(-50%, -50%) rotate(' + placement.angle + 'deg)';
      span.style.fontFamily = fontStack(layer.fontFamily || 'Arial');
      span.style.fontSize = Math.max(8, fontSizePx) + 'px';
      span.style.lineHeight = '1';
      span.style.whiteSpace = 'pre';
      span.style.color = layer.color || '#111111';
      if (pathStrokeWidth > 0) {
        span.style.webkitTextStroke = pathStrokeWidth + 'px ' + (layer.strokeColor || layer.stroke_color || '#1d4ed8');
        span.style.textStroke = pathStrokeWidth + 'px ' + (layer.strokeColor || layer.stroke_color || '#1d4ed8');
        span.style.paintOrder = 'stroke fill';
      }
      root.appendChild(span);
    });
    return root;
  }

  function seededTapeRandom(seed) {
    var state = Math.max(1, Math.floor(toNum(seed, 1))) % 2147483647;
    if (state <= 0) state += 2147483646;
    return function () {
      state = state * 16807 % 2147483647;
      return (state - 1) / 2147483646;
    };
  }

  function tapeStyleAssets(style) {
    var normalized = String(style || 'style-1');
    var count = normalized === 'style-2' ? 8 : 15;
    var assets = [];
    for (var i = 1; i <= count; i += 1) {
      assets.push('https://a.wahup.com/static/customizer/tape_styles/' + normalized + '/p' + i + '.png');
    }
    return assets;
  }

  function sampleTapePlacements(layer) {
    var points = Array.isArray(layer.points) ? layer.points : [];
    if (points.length < 2) return [];
    var rand = seededTapeRandom(layer.tapeRandomSeed || 1);
    var minSpacing = Math.max(2, Math.min(toNum(layer.tapeSpacingMin, 10), toNum(layer.tapeSpacingMax, 18)));
    var maxSpacing = Math.max(minSpacing, Math.max(toNum(layer.tapeSpacingMin, 10), toNum(layer.tapeSpacingMax, 18)));
    var assets = tapeStyleAssets(layer.tapeStyle || 'style-1');
    var placements = [];
    var remaining = rand() * minSpacing;
    for (var i = 1; i < points.length; i += 1) {
      var a = points[i - 1] || {};
      var b = points[i] || {};
      var ax = Array.isArray(a) ? toNum(a[0], 0) : toNum(a.x, 0);
      var ay = Array.isArray(a) ? toNum(a[1], 0) : toNum(a.y, 0);
      var bx = Array.isArray(b) ? toNum(b[0], 0) : toNum(b.x, 0);
      var by = Array.isArray(b) ? toNum(b[1], 0) : toNum(b.y, 0);
      var dx = bx - ax;
      var dy = by - ay;
      var length = Math.sqrt(dx * dx + dy * dy);
      if (length < 0.01) continue;
      while (remaining <= length) {
        var t = remaining / length;
        var jitter = (rand() - 0.5) * 4;
        placements.push({
          x: ax + dx * t + (-dy / length) * jitter,
          y: ay + dy * t + (dx / length) * jitter,
          angle: Math.atan2(dy, dx) * 180 / Math.PI + 90 + (rand() - 0.5) * 14,
          scale: 0.86 + rand() * 0.28,
          src: assets[Math.floor(rand() * assets.length) % assets.length]
        });
        remaining += minSpacing + rand() * (maxSpacing - minSpacing);
      }
      remaining -= length;
    }
    return placements;
  }

  function renderTapePathLayer(layer) {
    var wrap = document.createElement('div');
    wrap.className = 'wahup-custom-shirt-tape-path';
    wrap.style.position = 'relative';
    wrap.style.width = '100%';
    wrap.style.height = '100%';
    wrap.style.pointerEvents = 'none';
    wrap.style.overflow = 'visible';
    sampleTapePlacements(layer).forEach(function (piece) {
      if (!piece.src) return;
      var img = document.createElement('img');
      img.src = piece.src;
      img.alt = '';
      img.loading = 'lazy';
      img.style.position = 'absolute';
      img.style.left = piece.x + '%';
      img.style.top = piece.y + '%';
      img.style.width = (toNum(layer.tapeSize, 18) * piece.scale) + '%';
      img.style.maxWidth = 'none';
      img.style.maxHeight = 'none';
      img.style.pointerEvents = 'none';
      img.style.transformOrigin = 'center';
      img.style.transform = 'translate(-50%, -50%) rotate(' + piece.angle + 'deg)';
      img.style.filter = 'drop-shadow(0 2px 3px rgba(15,23,42,.14))';
      wrap.appendChild(img);
    });
    return wrap;
  }

  function imageTapeSlots(inset) {
    var i = Math.max(0, Math.min(toNum(inset, 10), 24));
    var edge = i * 0.7;
    var edgeTight = i * 0.6;
    var midA = 20 + i * 0.4;
    var midB = 22 + i * 0.4;
    var midC = 32 + i * 0.4;
    return [
      { x:i, y:i, angle:-45 }, { x:100 - i, y:i, angle:45 }, { x:i, y:100 - i, angle:45 }, { x:100 - i, y:100 - i, angle:-45 },
      { x:midA, y:edge, angle:-10 }, { x:100 - midA, y:edge, angle:10 }, { x:midA, y:100 - edge, angle:10 }, { x:100 - midA, y:100 - edge, angle:-10 },
      { x:edge, y:midB, angle:-78 }, { x:100 - edge, y:midB, angle:78 }, { x:edge, y:100 - midB, angle:78 }, { x:100 - edge, y:100 - midB, angle:-78 },
      { x:midC, y:edgeTight, angle:-18 }, { x:100 - midC, y:edgeTight, angle:18 }, { x:midC, y:100 - edgeTight, angle:18 }, { x:100 - midC, y:100 - edgeTight, angle:-18 }
    ];
  }

  function sampleImageTapePlacements(layer) {
    var count = Math.round(toNum(layer.imageTapeCount, 0));
    if ([0, 4, 8, 12, 16].indexOf(count) < 0) count = 0;
    if (!count) return [];
    var assets = tapeStyleAssets(layer.imageTapeStyle || 'style-1');
    var rand = seededTapeRandom(layer.imageTapeRandomSeed || layer.tapeRandomSeed || 1);
    return imageTapeSlots(layer.imageTapeInset).slice(0, count).map(function (slot) {
      return {
        x: slot.x + (rand() - 0.5) * 1.8,
        y: slot.y + (rand() - 0.5) * 1.8,
        angle: slot.angle + (rand() - 0.5) * 8,
        scale: 0.92 + rand() * 0.18,
        src: assets[Math.floor(rand() * assets.length) % assets.length]
      };
    });
  }

  function updateImageTapeOverlayRect(wrap, image, overlay) {
    if (!wrap || !image || !overlay) return;
    var wrapW = wrap.clientWidth || 0;
    var wrapH = wrap.clientHeight || 0;
    var naturalW = image.naturalWidth || 0;
    var naturalH = image.naturalHeight || 0;
    if (!wrapW || !wrapH || !naturalW || !naturalH) {
      overlay.style.left = '0';
      overlay.style.top = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      return;
    }
    var boxRatio = wrapW / wrapH;
    var imageRatio = naturalW / naturalH;
    var renderedW = wrapW;
    var renderedH = wrapH;
    var left = 0;
    var top = 0;
    if (boxRatio > imageRatio) {
      renderedH = wrapH;
      renderedW = wrapH * imageRatio;
      left = (wrapW - renderedW) / 2;
    } else {
      renderedW = wrapW;
      renderedH = wrapW / imageRatio;
      top = (wrapH - renderedH) / 2;
    }
    overlay.style.left = (left / wrapW * 100) + '%';
    overlay.style.top = (top / wrapH * 100) + '%';
    overlay.style.width = (renderedW / wrapW * 100) + '%';
    overlay.style.height = (renderedH / wrapH * 100) + '%';
  }

  function renderImageTapeOverlay(layer) {
    var overlay = document.createElement('div');
    overlay.className = 'wahup-custom-shirt-image-tape-overlay';
    overlay.style.position = 'absolute';
    overlay.style.left = '0';
    overlay.style.top = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.overflow = 'visible';
    overlay.style.pointerEvents = 'none';
    sampleImageTapePlacements(layer).forEach(function (piece) {
      if (!piece.src) return;
      var img = document.createElement('img');
      img.src = piece.src;
      img.alt = '';
      img.loading = 'lazy';
      img.style.position = 'absolute';
      img.style.left = piece.x + '%';
      img.style.top = piece.y + '%';
      img.style.width = (toNum(layer.imageTapeSize, 24) * piece.scale) + '%';
      img.style.maxWidth = 'none';
      img.style.maxHeight = 'none';
      img.style.pointerEvents = 'none';
      img.style.transformOrigin = 'center';
      img.style.transform = 'translate(-50%, -50%) rotate(' + piece.angle + 'deg)';
      img.style.filter = 'drop-shadow(0 2px 3px rgba(15,23,42,.16))';
      img.style.opacity = '.92';
      overlay.appendChild(img);
    });
    return overlay;
  }

  function renderImageLayer(layer) {
    var wrap = document.createElement('div');
    wrap.className = 'wahup-custom-shirt-image-tape-wrap';
    wrap.style.position = 'relative';
    wrap.style.width = '100%';
    wrap.style.height = '100%';
    wrap.style.display = 'grid';
    wrap.style.placeItems = 'center';
    wrap.style.overflow = 'visible';
    wrap.style.pointerEvents = 'none';
    var img = document.createElement('img');
    img.src = layer.src;
    img.alt = '';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';
    img.style.display = 'block';
    wrap.appendChild(img);
    if (toNum(layer.imageTapeCount, 0) > 0) {
      var overlay = renderImageTapeOverlay(layer);
      wrap.appendChild(overlay);
      var syncOverlay = function () { updateImageTapeOverlayRect(wrap, img, overlay); };
      img.addEventListener('load', syncOverlay);
      window.requestAnimationFrame(syncOverlay);
      window.setTimeout(syncOverlay, 120);
    }
    return wrap;
  }

  function renderDesignLayer(layer, design, fields, form, host, region, index, root) {
    var el = document.createElement('div');
    el.className = 'wahup-custom-shirt-text-slot wahup-custom-shirt-design-layer';
    el.style.setProperty('--wahup-layer-anim-index', String(Math.max(0, Number(index || 0))));
    el.style.animationDelay = (Math.max(0, Number(index || 0)) * 120) + 'ms';
    el.style.left = (Number(layer.x || 50) - Number(layer.width || 60) / 2) + '%';
    el.style.top = (Number(layer.y || 50) - Number(layer.height || 12) / 2) + '%';
    el.style.width = Number(layer.width || 60) + '%';
    el.style.height = Number(layer.height || 12) + '%';
    el.style.zIndex = Number(layer.zIndex || 10);
    el.style.transform = 'rotate(' + Number(layer.rotation || 0) + 'deg) scale(' + (Math.max(10, Math.min(300, Number(layer.scale || 100))) / 100) + ')';
    if (layer.type === 'image') {
      var imageLayerSrc = layerImageSource(layer, fields, form, root);
      if (!imageLayerSrc) return el;
      el.className = 'wahup-custom-shirt-design-image wahup-custom-shirt-design-layer';
      el.appendChild(renderImageLayer(Object.assign({}, layer, { src: imageLayerSrc })));
      return el;
    }
    if (layer.type === 'tape-path') {
      el.appendChild(renderTapePathLayer(layer));
      return el;
    }
    var hostWidth = Math.max(1, host.clientWidth || 520);
    var designWidth = Math.max(1, Number(design.width || 1024));
    var fontSizePx = Math.max(8, Number(layer.fontSize || 72) / designWidth * hostWidth);
    var viewportScale = hostWidth / designWidth;
    layer.__wahupViewportScale = viewportScale;
    el.style.color = layer.color || '#111111';
    el.style.fontSize = fontSizePx + 'px';
    var strokeWidth = Math.max(0, Number(layer.strokeWidth || layer.stroke_width || 0));
    if (strokeWidth > 0 && layer.type !== 'color-text' && layer.fontKind !== 'color') {
      var strokeColor = layer.strokeColor || layer.stroke_color || '#1d4ed8';
      var scaledStrokeWidth = strokeWidth * viewportScale;
      el.style.webkitTextStroke = scaledStrokeWidth + 'px ' + strokeColor;
      el.style.textStroke = scaledStrokeWidth + 'px ' + strokeColor;
      el.style.paintOrder = 'stroke fill';
    }
    var layerFont = findDesignFont(layer.fontFamily);
    var layerFamily = ensureFont(layerFont) || layer.fontFamily || 'Georgia';
    el.style.fontFamily = fontStack(layerFamily || layer.fontFamily || 'Arial');
    el.style.letterSpacing = Number(layer.letterSpacing || 0) + 'px';
    el.style.textAlign = layer.align || 'center';
    var text = layerText(layer, fields, form);
    el.style.setProperty('--wahup-layer-typing-steps', String(Math.max(4, Math.min(40, String(text || '').length || 12))));
    var typingWrap = document.createElement('span');
    typingWrap.className = 'wahup-custom-shirt-layer-typing';
    var colorFontNode = (layer.type === 'color-text' || layer.fontKind === 'color') ? renderColorFontLayer(layer, text, fontSizePx, 1) : null;
    if (colorFontNode) typingWrap.appendChild(colorFontNode);
    else if (layer.textPath && layer.textPath !== 'none') typingWrap.appendChild(renderTextPath(layer, text, fontSizePx));
    else typingWrap.textContent = text;
    el.appendChild(typingWrap);
    return el;
  }

  function renderPreview(template, mockup, form, root) {
    ensurePreviewStage(root);
    ensurePreviewZoomControl(root);
    var image = root.querySelector('[data-preview-mockup], [data-inline-preview-image]');
    var layerHost = root.querySelector('[data-preview-slots], [data-inline-preview-slots]');
    if (!image || !layerHost || !mockup) return;
    image.src = mockup.image_url || '';
    if (!image.complete) image.onload = function () {
      var refreshRoot = root;
      window.requestAnimationFrame(function () {
        if (refreshRoot && typeof refreshRoot.__wahupCustomShirtRefresh === 'function') refreshRoot.__wahupCustomShirtRefresh();
      });
    };
    layerHost.innerHTML = '';
    var region = designRegion(template, mockup);
    positionLayerHost(layerHost, image, region);
    var fields = editableFields(template, mockup, root);
    var design = designPayload(template, mockup);
    if (design && Array.isArray(design.layers) && design.layers.length) {
      var animateLayers = !root.__wahupLayerAnimationPlayed;
      layerHost.classList.toggle('is-attention', animateLayers);
      if (animateLayers) {
        root.__wahupLayerAnimationPlayed = true;
        window.setTimeout(function () { layerHost.classList.remove('is-attention'); }, 3800);
      }
      design.layers.slice().sort(function (a, b) { return Number(a.zIndex || 0) - Number(b.zIndex || 0); }).forEach(function (layer, index) {
        layerHost.appendChild(renderDesignLayer(layer, design, fields, form, layerHost, region, index, root));
      });
      if (root.__wahupPreviewZoom && root.__wahupPreviewZoom.active) window.requestAnimationFrame(function () { applyPreviewZoom(root); });
      return;
    }
    fields.forEach(function (slot) {
      var box = slot.box || {};
      var x = Number(box.x || 50), y = Number(box.y || 50), w = Number(box.width || 60), h = Number(box.height || 12);
      var el = document.createElement('div');
      el.className = 'wahup-custom-shirt-text-slot';
      el.style.left = (x - w / 2) + '%';
      el.style.top = (y - h / 2) + '%';
      el.style.width = w + '%';
      el.style.height = h + '%';
      el.style.zIndex = Number(box.z_index || 10);
      el.style.transform = 'rotate(' + Number(box.rotation || 0) + 'deg)';
      el.style.color = slot.default_color || '#111111';
      el.style.fontSize = Math.max(12, Number(box.font_size || 36)) + 'px';
      var fontFamily = ensureFont(slot);
      if (fontFamily) el.style.fontFamily = fontStack(fontFamily);
      el.style.letterSpacing = Number(slot.letter_spacing || 0) + 'px';
      el.style.lineHeight = Number(slot.line_height || 1);
      el.style.opacity = Math.max(0, Math.min(1, Number(slot.opacity || 1)));
      el.textContent = fieldText(slot, form);
      layerHost.appendChild(el);
    });
    if (root.__wahupPreviewZoom && root.__wahupPreviewZoom.active) window.requestAnimationFrame(function () { applyPreviewZoom(root); });
  }

  function renderTextFields(container, template, mockup, existingValues, root) {
    var fields = editableFields(template, mockup, root);
    container.innerHTML = fields.map(function (field) {
      var value = valueForField(field, existingValues);
      if (field.field_type === 'image_layer') {
        var photoInputId = 'photo_upload_' + field.id;
        var hiddenId = field.field_id || ('image_layer_' + field.id);
        var previewUrl = value || field.source_image || '';
        return '<div class="wahup-custom-shirt-text-field-row wahup-custom-shirt-photo-field-row">' +
          '<input type="hidden" id="' + escapeHtml(hiddenId) + '" name="' + escapeHtml(hiddenId) + '" data-image-layer-id="' + escapeHtml(field.layer_id) + '" data-slot-label="' + escapeHtml(field.label) + '" value="' + escapeHtml(value) + '">' +
          '<div class="wahup-custom-shirt-photo-upload" data-photo-upload-row="' + escapeHtml(field.layer_id) + '">' +
            '<button type="button" class="wahup-custom-shirt-photo-preview" data-photo-upload-button="1" aria-label="Upload ' + escapeHtml(field.label) + '">' +
              (previewUrl ? '<img src="' + escapeHtml(previewUrl) + '" alt="" loading="lazy" decoding="async">' : '<span>+</span>') +
            '</button>' +
            '<div class="wahup-custom-shirt-photo-main">' +
              '<label class="wahup-custom-shirt-label" for="' + escapeHtml(photoInputId) + '">' + escapeHtml(field.label) + '</label>' +
              '<button type="button" class="wahup-custom-shirt-photo-button" data-photo-upload-button="1">Upload custom photo</button>' +
              '<span class="wahup-custom-shirt-photo-status" data-photo-upload-status="1">' + (value ? 'Photo selected' : 'No photo selected') + '</span>' +
            '</div>' +
            '<input type="file" id="' + escapeHtml(photoInputId) + '" accept="image/*" data-photo-upload-input="1" hidden>' +
          '</div>' +
          '</div>';
      }
      var inputId = field.field_type === 'layer' ? field.field_id : 'slot_' + field.id;
      var maxLength = field.max_length || (field.field_type === 'layer' ? 60 : 40);
      var layerAttr = field.field_type === 'layer' ? ' data-layer-id="' + escapeHtml(field.layer_id) + '"' : '';
      var editIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0 0-3L17.5 5.5a2.1 2.1 0 0 0-3 0L4 16v4Z"></path><path d="M13.5 6.5l4 4"></path></svg>';
      var inputHtml = '<div class="wahup-custom-shirt-text-input-wrap">' +
        '<input type="text" id="' + escapeHtml(inputId) + '" name="' + escapeHtml(inputId) + '" data-mobile-text-source="1"' + layerAttr + ' data-slot-label="' + escapeHtml(field.label) + '" maxlength="' + maxLength + '" placeholder="' + escapeHtml(field.placeholder || field.label) + '" value="' + escapeHtml(value) + '" autocomplete="off">' +
        '<button type="button" class="wahup-custom-shirt-text-edit" data-mobile-text-edit="1" aria-label="Edit ' + escapeHtml(field.label) + '">' + editIcon + '</button>' +
        '</div>';
      return '<div class="wahup-custom-shirt-text-field-row">' +
        inputHtml +
        '<label class="wahup-custom-shirt-label" for="' + escapeHtml(inputId) + '">' + escapeHtml(field.label) + '</label>' +
        '</div>';
    }).join('');
    bindPhotoFieldUploads(container);
  }

  function uploadCustomerPhoto(root, file) {
    var body = new FormData();
    body.append('file', file, file && file.name ? file.name : 'custom-photo.png');
    return fetch(apiBase(root) + 'custom-photo/upload/', {
      method: 'POST',
      credentials: 'omit',
      mode: 'cors',
      body: body
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok || !payload.ok || !payload.url) throw new Error(payload.error || 'Photo upload failed.');
          return payload.url;
        });
      });
  }

  var PHOTO_FILTERS = {
    none: { label:'Original', css:'none' },
    vivid: { label:'Vivid', css:'contrast(1.18) saturate(1.35)' },
    warm: { label:'Warm', css:'sepia(.26) saturate(1.16) contrast(1.06)' },
    cool: { label:'Cool', css:'saturate(1.1) hue-rotate(188deg) contrast(1.06)' },
    bw: { label:'B&W', css:'grayscale(1) contrast(1.16)' },
    fade: { label:'Fade', css:'contrast(.88) saturate(.72) brightness(1.1)' }
  };

  function loadImageFromUrl(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Could not load photo.')); };
      img.src = src;
    });
  }

  function clampColor(value) {
    return Math.max(0, Math.min(255, Math.round(value)));
  }

  function adjustSaturation(r, g, b, amount) {
    var gray = r * 0.2126 + g * 0.7152 + b * 0.0722;
    return [
      gray + (r - gray) * amount,
      gray + (g - gray) * amount,
      gray + (b - gray) * amount
    ];
  }

  function adjustContrast(value, amount) {
    return (value - 128) * amount + 128;
  }

  function applyPhotoFilterPixels(ctx, size, filterKey) {
    filterKey = filterKey || 'none';
    if (!ctx || filterKey === 'none') return;
    var imageData;
    try {
      imageData = ctx.getImageData(0, 0, size, size);
    } catch (error) {
      return;
    }
    var data = imageData.data;
    for (var i = 0; i < data.length; i += 4) {
      var r = data[i], g = data[i + 1], b = data[i + 2];
      var out;
      if (filterKey === 'bw') {
        var gray = r * 0.299 + g * 0.587 + b * 0.114;
        gray = adjustContrast(gray, 1.16);
        r = g = b = gray;
      } else if (filterKey === 'vivid') {
        out = adjustSaturation(r, g, b, 1.35);
        r = adjustContrast(out[0], 1.18);
        g = adjustContrast(out[1], 1.18);
        b = adjustContrast(out[2], 1.18);
      } else if (filterKey === 'warm') {
        var sr = r * 0.393 + g * 0.769 + b * 0.189;
        var sg = r * 0.349 + g * 0.686 + b * 0.168;
        var sb = r * 0.272 + g * 0.534 + b * 0.131;
        r = adjustContrast(r * 0.72 + sr * 0.28 + 10, 1.06);
        g = adjustContrast(g * 0.78 + sg * 0.22 + 3, 1.04);
        b = adjustContrast(b * 0.82 + sb * 0.18 - 6, 1.02);
      } else if (filterKey === 'cool') {
        out = adjustSaturation(r, g, b, 1.12);
        r = adjustContrast(out[0] * 0.9, 1.05);
        g = adjustContrast(out[1] * 1.02, 1.05);
        b = adjustContrast(out[2] * 1.16 + 8, 1.06);
      } else if (filterKey === 'fade') {
        out = adjustSaturation(r, g, b, 0.72);
        r = adjustContrast(out[0], 0.88) + 18;
        g = adjustContrast(out[1], 0.88) + 18;
        b = adjustContrast(out[2], 0.88) + 18;
      }
      data[i] = clampColor(r);
      data[i + 1] = clampColor(g);
      data[i + 2] = clampColor(b);
    }
    ctx.putImageData(imageData, 0, 0);
  }

  function drawPhotoCrop(canvas, image, state) {
    if (!canvas || !image || !state) return;
    var size = state.outputSize || 1024;
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.save();
    ctx.clearRect(0, 0, size, size);
    ctx.fillStyle = '#f8fafc';
    ctx.fillRect(0, 0, size, size);
    ctx.filter = 'none';
    var w = image.naturalWidth || image.width || 1;
    var h = image.naturalHeight || image.height || 1;
    var baseScale = Math.max(size / w, size / h);
    var scale = baseScale * Math.max(1, Math.min(Number(state.zoom || 1), 4));
    var drawW = w * scale;
    var drawH = h * scale;
    clampPhotoPan(image, state);
    var x = (size - drawW) / 2 + Number(state.panX || 0);
    var y = (size - drawH) / 2 + Number(state.panY || 0);
    ctx.drawImage(image, x, y, drawW, drawH);
    applyPhotoFilterPixels(ctx, size, state.filter);
    ctx.restore();
  }

  function clampPhotoZoom(value) {
    return Math.max(1, Math.min(Number(value || 1), 4));
  }

  function clampPhotoPan(image, state) {
    if (!image || !state) return;
    var size = state.outputSize || 1024;
    var w = image.naturalWidth || image.width || 1;
    var h = image.naturalHeight || image.height || 1;
    var baseScale = Math.max(size / w, size / h);
    var scale = baseScale * clampPhotoZoom(state.zoom);
    var drawW = w * scale;
    var drawH = h * scale;
    var maxPanX = Math.max(0, (drawW - size) / 2);
    var maxPanY = Math.max(0, (drawH - size) / 2);
    state.panX = Math.max(-maxPanX, Math.min(maxPanX, Number(state.panX || 0)));
    state.panY = Math.max(-maxPanY, Math.min(maxPanY, Number(state.panY || 0)));
  }

  function zoomPhotoCrop(state, nextZoom, originX, originY, canvas) {
    if (!state || !canvas) return;
    var oldZoom = clampPhotoZoom(state.zoom);
    var newZoom = clampPhotoZoom(nextZoom);
    if (Math.abs(newZoom - oldZoom) < 0.001) return;
    var rect = canvas.getBoundingClientRect();
    var factor = state.outputSize / Math.max(1, rect.width || state.outputSize);
    var centerX = typeof originX === 'number' ? (originX - rect.left) * factor : state.outputSize / 2;
    var centerY = typeof originY === 'number' ? (originY - rect.top) * factor : state.outputSize / 2;
    var ratio = newZoom / oldZoom;
    state.panX = centerX - (centerX - Number(state.panX || 0)) * ratio;
    state.panY = centerY - (centerY - Number(state.panY || 0)) * ratio;
    state.zoom = newZoom;
  }

  function canvasToFile(canvas, originalFile) {
    return new Promise(function (resolve, reject) {
      if (!canvas || !canvas.toBlob) {
        reject(new Error('Photo editor is not supported on this browser.'));
        return;
      }
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error('Could not process photo.'));
          return;
        }
        var baseName = originalFile && originalFile.name ? originalFile.name.replace(/\.[^.]+$/, '') : 'custom-photo';
        try {
          resolve(new File([blob], baseName + '-square.jpg', { type:'image/jpeg' }));
        } catch (error) {
          blob.name = baseName + '-square.jpg';
          resolve(blob);
        }
      }, 'image/jpeg', 0.92);
    });
  }

  function editCustomerPhoto(root, file) {
    return new Promise(function (resolve, reject) {
      if (!file || !file.type || !/^image\//i.test(file.type)) {
        reject(new Error('Please choose an image file.'));
        return;
      }
      var objectUrl = URL.createObjectURL(file);
      loadImageFromUrl(objectUrl)
        .then(function (image) {
          var modal = document.createElement('div');
          modal.className = 'wahup-custom-shirt-photo-editor';
          modal.setAttribute('role', 'dialog');
          modal.setAttribute('aria-modal', 'true');
          modal.innerHTML =
            '<div class="wahup-custom-shirt-photo-editor__panel">' +
              '<div class="wahup-custom-shirt-photo-editor__head">' +
                '<div><p>Crop custom photo</p></div>' +
                '<button type="button" class="wahup-custom-shirt-photo-editor__close" data-photo-editor-cancel aria-label="Cancel photo edit">×</button>' +
              '</div>' +
              '<canvas class="wahup-custom-shirt-photo-editor__canvas" data-photo-editor-canvas></canvas>' +
              '<div class="wahup-custom-shirt-photo-editor__controls">' +
                '<div class="wahup-custom-shirt-photo-editor__filters" data-photo-editor-filters></div>' +
              '</div>' +
              '<div class="wahup-custom-shirt-photo-editor__status" data-photo-editor-status aria-live="polite"></div>' +
              '<div class="wahup-custom-shirt-photo-editor__actions">' +
                '<button type="button" class="wahup-custom-shirt-photo-editor__secondary" data-photo-editor-cancel>Cancel</button>' +
                '<button type="button" class="wahup-custom-shirt-photo-editor__primary" data-photo-editor-apply>Apply photo</button>' +
              '</div>' +
            '</div>';
          document.body.appendChild(modal);
          var canvas = modal.querySelector('[data-photo-editor-canvas]');
          var filters = modal.querySelector('[data-photo-editor-filters]');
          var status = modal.querySelector('[data-photo-editor-status]');
          var applyButton = modal.querySelector('[data-photo-editor-apply]');
          var cancelButtons = modal.querySelectorAll('[data-photo-editor-cancel]');
          var state = { outputSize:1024, zoom:1, panX:0, panY:0, filter:'none', dragging:false, pointers:{} };
          trackEvent(root, 'custom_shirt_photo_editor_open', {
            file_type: file.type || '',
            file_size: file.size || 0
          });
          var setApplying = function (isApplying, message) {
            state.applying = !!isApplying;
            modal.classList.toggle('is-applying', !!isApplying);
            modal.setAttribute('aria-busy', isApplying ? 'true' : 'false');
            if (status) {
              status.textContent = message || '';
              status.classList.toggle('is-error', false);
              status.classList.toggle('is-success', false);
            }
            if (applyButton) {
              applyButton.disabled = !!isApplying;
              applyButton.innerHTML = isApplying ? '<span class="wahup-custom-shirt-photo-editor__spinner" aria-hidden="true"></span><span>Applying...</span>' : 'Apply photo';
            }
            cancelButtons.forEach(function (button) { button.disabled = !!isApplying; });
            if (filters) filters.querySelectorAll('button').forEach(function (button) { button.disabled = !!isApplying; });
          };
          var setApplyError = function (message) {
            state.applying = false;
            modal.classList.remove('is-applying', 'is-applied');
            modal.setAttribute('aria-busy', 'false');
            if (status) {
              status.textContent = message || 'Could not apply photo.';
              status.classList.add('is-error');
              status.classList.remove('is-success');
            }
            if (applyButton) {
              applyButton.disabled = false;
              applyButton.innerHTML = 'Try again';
            }
            cancelButtons.forEach(function (button) { button.disabled = false; });
            if (filters) filters.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
          };
          var setApplied = function () {
            state.applying = false;
            modal.classList.remove('is-applying');
            modal.classList.add('is-applied');
            modal.setAttribute('aria-busy', 'false');
            if (status) {
              status.textContent = 'Photo applied.';
              status.classList.add('is-success');
              status.classList.remove('is-error');
            }
            if (applyButton) {
              applyButton.disabled = true;
              applyButton.innerHTML = '<span aria-hidden="true">✓</span><span>Applied</span>';
            }
          };
          Object.keys(PHOTO_FILTERS).forEach(function (key) {
            var button = document.createElement('button');
            button.type = 'button';
            button.title = PHOTO_FILTERS[key].label;
            button.setAttribute('aria-label', PHOTO_FILTERS[key].label + ' filter');
            var swatch = document.createElement('span');
            swatch.className = 'wahup-custom-shirt-photo-editor__filter-swatch';
            swatch.style.backgroundImage = 'url("' + objectUrl.replace(/"/g, '%22') + '")';
            swatch.style.filter = PHOTO_FILTERS[key].css;
            var label = document.createElement('span');
            label.className = 'wahup-custom-shirt-photo-editor__filter-label';
            label.textContent = PHOTO_FILTERS[key].label;
            button.appendChild(swatch);
            button.appendChild(label);
            button.setAttribute('data-photo-filter', key);
            if (key === state.filter) button.className = 'is-active';
            filters.appendChild(button);
          });
          var update = function () { drawPhotoCrop(canvas, image, state); };
          var cleanup = function () {
            try { URL.revokeObjectURL(objectUrl); } catch (error) {}
            modal.remove();
          };
          update();
          filters.addEventListener('click', function (event) {
            var button = event.target && event.target.closest && event.target.closest('[data-photo-filter]');
            if (!button) return;
            event.preventDefault();
            event.stopPropagation();
            state.filter = button.getAttribute('data-photo-filter') || 'none';
            filters.querySelectorAll('[data-photo-filter]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
            canvas.setAttribute('data-active-filter', state.filter);
            update();
            trackEvent(root, 'custom_shirt_photo_filter_select', { filter:state.filter });
          });
          var pointerList = function () {
            return Object.keys(state.pointers || {}).map(function (key) { return state.pointers[key]; });
          };
          var pinchDistance = function (points) {
            if (!points || points.length < 2) return 0;
            var dx = points[0].x - points[1].x;
            var dy = points[0].y - points[1].y;
            return Math.sqrt(dx * dx + dy * dy);
          };
          var pinchCenter = function (points) {
            return { x:(points[0].x + points[1].x) / 2, y:(points[0].y + points[1].y) / 2 };
          };
          canvas.addEventListener('pointerdown', function (event) {
            state.pointers[event.pointerId] = { x:event.clientX, y:event.clientY };
            var points = pointerList();
            if (points.length >= 2) {
              state.dragging = false;
              state.pinching = true;
              state.startPinchDistance = pinchDistance(points);
              state.startPinchZoom = state.zoom;
              try { canvas.setPointerCapture(event.pointerId); } catch (error) {}
              event.preventDefault();
              return;
            }
            state.dragging = true;
            state.pinching = false;
            state.startX = event.clientX;
            state.startY = event.clientY;
            state.startPanX = state.panX;
            state.startPanY = state.panY;
            try { canvas.setPointerCapture(event.pointerId); } catch (error) {}
            event.preventDefault();
          });
          canvas.addEventListener('pointermove', function (event) {
            if (state.pointers[event.pointerId]) state.pointers[event.pointerId] = { x:event.clientX, y:event.clientY };
            var points = pointerList();
            if (state.pinching && points.length >= 2) {
              var distance = pinchDistance(points);
              var center = pinchCenter(points);
              if (state.startPinchDistance > 0) {
                zoomPhotoCrop(state, state.startPinchZoom * (distance / state.startPinchDistance), center.x, center.y, canvas);
                update();
              }
              event.preventDefault();
              return;
            }
            if (!state.dragging) return;
            var rect = canvas.getBoundingClientRect();
            var factor = state.outputSize / Math.max(1, rect.width || state.outputSize);
            state.panX = state.startPanX + (event.clientX - state.startX) * factor;
            state.panY = state.startPanY + (event.clientY - state.startY) * factor;
            update();
            event.preventDefault();
          });
          ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (eventName) {
            canvas.addEventListener(eventName, function (event) {
              delete state.pointers[event.pointerId];
              var points = pointerList();
              state.pinching = false;
              if (points.length === 1) {
                state.dragging = false;
              } else {
                state.dragging = false;
              }
            });
          });
          canvas.addEventListener('wheel', function (event) {
            var delta = event.deltaY || 0;
            var nextZoom = state.zoom * (delta > 0 ? 0.92 : 1.08);
            zoomPhotoCrop(state, nextZoom, event.clientX, event.clientY, canvas);
            update();
            event.preventDefault();
          }, { passive:false });
          canvas.addEventListener('dblclick', function (event) {
            zoomPhotoCrop(state, state.zoom > 1.05 ? 1 : 1.8, event.clientX, event.clientY, canvas);
            update();
            event.preventDefault();
          });
          modal.addEventListener('click', function (event) {
            if (state.applying) return;
            if (event.target === modal || event.target.closest('[data-photo-editor-cancel]')) {
              cleanup();
              trackEvent(root, 'custom_shirt_photo_editor_cancel', { filter:state.filter });
              reject(new Error('Photo edit cancelled.'));
            }
          });
          applyButton.addEventListener('click', function () {
            if (state.applying) return;
            setApplying(true, 'Applying photo...');
            update();
            trackEvent(root, 'custom_shirt_photo_apply_click', {
              filter: state.filter,
              zoom: Number(state.zoom || 1)
            });
            var minimumFeedback = new Promise(function (done) { setTimeout(done, 320); });
            Promise.all([canvasToFile(canvas, file), minimumFeedback]).then(function (result) {
              var editedFile = result[0];
              setApplied();
              trackEvent(root, 'custom_shirt_photo_apply_success', {
                filter: state.filter,
                zoom: Number(state.zoom || 1)
              });
              setTimeout(function () {
                cleanup();
                resolve(editedFile);
              }, 180);
            }).catch(function (error) {
              setApplyError(error && error.message ? error.message : 'Could not apply photo.');
              trackEvent(root, 'custom_shirt_photo_apply_error', {
                filter: state.filter,
                error_message: (error && error.message) || 'Could not apply photo.'
              });
            });
          });
        })
        .catch(function (error) {
          try { URL.revokeObjectURL(objectUrl); } catch (revokeError) {}
          reject(error);
        });
    });
  }

  function bindPhotoFieldUploads(container) {
    if (!container || container.__wahupPhotoUploadsBound) return;
    container.__wahupPhotoUploadsBound = true;
    container.addEventListener('click', function (event) {
      var picker = event.target;
      if (!picker || !picker.matches || !picker.matches('[data-photo-upload-input]')) return;
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }, true);
    container.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('[data-photo-upload-button]');
      if (!button || !container.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var row = button.closest('[data-photo-upload-row]');
      var input = row && row.querySelector('[data-photo-upload-input]');
      if (input) {
        var blockInputClick = function (inputEvent) {
          inputEvent.stopPropagation();
          if (typeof inputEvent.stopImmediatePropagation === 'function') inputEvent.stopImmediatePropagation();
        };
        input.addEventListener('click', blockInputClick, true);
        input.addEventListener('click', blockInputClick);
        input.click();
        window.setTimeout(function () {
          input.removeEventListener('click', blockInputClick, true);
          input.removeEventListener('click', blockInputClick);
        }, 0);
      }
    });
    container.addEventListener('change', function (event) {
      var picker = event.target;
      if (!picker || !picker.matches || !picker.matches('[data-photo-upload-input]')) return;
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var file = picker.files && picker.files[0];
      if (!file) return;
      var row = picker.closest('[data-photo-upload-row]');
      var fieldRow = picker.closest('.wahup-custom-shirt-photo-field-row');
      var hidden = fieldRow && fieldRow.querySelector('[data-image-layer-id]');
      var status = row && row.querySelector('[data-photo-upload-status]');
      var preview = row && row.querySelector('.wahup-custom-shirt-photo-preview');
      var root = container.closest('#wahup-custom-shirt-popup-root') || document.getElementById('wahup-custom-shirt-popup-root');
      if (!root && container.closest) root = container.closest('[data-wahup-custom-shirt-inline-root]');
      var layerId = hidden ? hidden.getAttribute('data-image-layer-id') : row && row.getAttribute('data-photo-upload-row');
      trackEvent(root, 'custom_shirt_photo_select', {
        layer_id: layerId || '',
        file_type: file.type || '',
        file_size: file.size || 0
      });
      if (status) status.textContent = 'Editing photo...';
      if (preview) {
        var objectUrl = URL.createObjectURL(file);
        preview.innerHTML = '<img src="' + escapeHtml(objectUrl) + '" alt="" decoding="async">';
      }
      editCustomerPhoto(root, file)
        .then(function (editedFile) {
          if (status) status.textContent = 'Uploading photo...';
          trackEvent(root, 'custom_shirt_photo_upload_start', {
            layer_id: layerId || '',
            file_type: editedFile.type || file.type || '',
            file_size: editedFile.size || file.size || 0
          });
          if (preview) {
            var editedObjectUrl = URL.createObjectURL(editedFile);
            preview.innerHTML = '<img src="' + escapeHtml(editedObjectUrl) + '" alt="" decoding="async">';
            window.setTimeout(function () { try { URL.revokeObjectURL(editedObjectUrl); } catch (error) {} }, 30000);
          }
          return uploadCustomerPhoto(root, editedFile);
        })
        .then(function (url) {
          if (hidden) {
            hidden.value = url;
            hidden.setAttribute('value', url);
          }
          if (root && layerId) {
            root.__wahupUploadedImages = root.__wahupUploadedImages || {};
            root.__wahupUploadedImages[String(layerId)] = url;
          }
          if (status) status.textContent = file.name || 'Photo selected';
          if (preview) preview.innerHTML = '<img src="' + escapeHtml(url) + '" alt="" decoding="async">';
          if (root && typeof root.__wahupCustomShirtRefresh === 'function') root.__wahupCustomShirtRefresh();
          trackEvent(root, 'custom_shirt_photo_upload_success', {
            layer_id: layerId || '',
            has_photo_url: !!url
          });
        })
        .catch(function (error) {
          if (status) status.textContent = error && error.message === 'Photo edit cancelled.' ? 'No photo selected' : (error.message || 'Could not upload photo.');
          picker.value = '';
          trackEvent(root, error && error.message === 'Photo edit cancelled.' ? 'custom_shirt_photo_upload_cancel' : 'custom_shirt_photo_upload_error', {
            layer_id: layerId || '',
            error_message: (error && error.message) || 'Could not upload photo.'
          });
        });
    });
  }

  function isMobileTextEditorMode() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 820px), (pointer: coarse)').matches);
  }

  function textSourceSelector() {
    return '.wahup-custom-shirt-controls input[type="text"][data-mobile-text-source], .wahup-custom-shirt-controls input:not([type])[data-mobile-text-source], .wahup-custom-shirt-controls textarea[data-mobile-text-source]';
  }

  function setMobilePreviewPortal(root, enabled) {
    if (!root) return;
    var card = root.__wahupMobilePreviewCard || root.querySelector('.wahup-custom-shirt-preview-card');
    if (!card) return;
    if (enabled) {
      if (root.__wahupMobilePreviewPortaled) return;
      var placeholder = document.createComment('wahup-mobile-preview-placeholder');
      root.__wahupMobilePreviewCard = card;
      root.__wahupMobilePreviewPlaceholder = placeholder;
      root.__wahupMobilePreviewParent = card.parentNode;
      if (card.parentNode) card.parentNode.insertBefore(placeholder, card);
      root.appendChild(card);
      root.__wahupMobilePreviewPortaled = true;
      return;
    }
    if (!root.__wahupMobilePreviewPortaled) return;
    var parent = root.__wahupMobilePreviewParent;
    var marker = root.__wahupMobilePreviewPlaceholder;
    if (parent && marker && marker.parentNode === parent) {
      parent.insertBefore(card, marker);
      parent.removeChild(marker);
    }
    root.__wahupMobilePreviewPortaled = false;
    root.__wahupMobilePreviewPlaceholder = null;
    root.__wahupMobilePreviewParent = null;
  }

  function captureMobileTextEditorState(root, editor) {
    if (!root || !editor || editor.__wahupRestoreState) return;
    var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
    var scrollables = Array.prototype.slice.call(root.querySelectorAll('.wahup-custom-shirt-colors'));
    editor.__wahupRestoreState = {
      windowX: window.pageXOffset || document.documentElement.scrollLeft || 0,
      windowY: window.pageYOffset || document.documentElement.scrollTop || 0,
      dialog: dialog ? { node: dialog, top: dialog.scrollTop || 0, left: dialog.scrollLeft || 0 } : null,
      scrollables: scrollables.map(function (node) {
        return { node: node, top: node.scrollTop || 0, left: node.scrollLeft || 0 };
      })
    };
  }

  function restoreMobileTextEditorState(editor) {
    var state = editor && editor.__wahupRestoreState;
    if (!state) return;
    function restore() {
      if (state.dialog && state.dialog.node) {
        state.dialog.node.scrollTop = state.dialog.top;
        state.dialog.node.scrollLeft = state.dialog.left;
      }
      state.scrollables.forEach(function (item) {
        if (!item.node) return;
        item.node.scrollTop = item.top;
        item.node.scrollLeft = item.left;
      });
      try { window.scrollTo(state.windowX, state.windowY); } catch (error) {}
    }
    restore();
    window.requestAnimationFrame(function () {
      restore();
      window.setTimeout(restore, 180);
    });
    editor.__wahupRestoreState = null;
  }

  function positionMobileTextEditor(editor) {
    if (!editor || editor.hidden) return;
    var root = editor.closest && editor.closest('#wahup-custom-shirt-popup-root');
    var viewport = window.visualViewport;
    var keyboardInset = 0;
    var visibleHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (viewport) keyboardInset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
    if (viewport && viewport.height) visibleHeight = viewport.height;
    editor.style.bottom = 'calc(' + Math.round(keyboardInset + 10) + 'px + env(safe-area-inset-bottom))';
    if (root) {
      var editorHeight = Math.max(84, editor.offsetHeight || 112);
      var layoutHeight = window.innerHeight || document.documentElement.clientHeight || visibleHeight || 0;
      var previewTop = Math.max(12, Math.round((viewport && viewport.offsetTop ? viewport.offsetTop : 0) + 12));
      var dockTop = Math.max(0, layoutHeight - keyboardInset - editorHeight - 10);
      var availablePreviewHeight = Math.max(132, dockTop - previewTop - 14);
      var availablePreviewWidth = Math.max(180, (window.innerWidth || document.documentElement.clientWidth || 390) - 24);
      var previewMax = Math.max(132, Math.min(availablePreviewWidth, availablePreviewHeight, 360));
      root.style.setProperty('--wahup-mobile-visible-height', Math.round(visibleHeight) + 'px');
      root.style.setProperty('--wahup-mobile-keyboard-inset', Math.round(keyboardInset) + 'px');
      root.style.setProperty('--wahup-mobile-editor-height', Math.round(editorHeight) + 'px');
      root.style.setProperty('--wahup-mobile-preview-top', previewTop + 'px');
      root.style.setProperty('--wahup-mobile-preview-max', previewMax + 'px');
    }
  }

  function ensureMobileTextEditor(root) {
    if (root.__wahupMobileTextEditor) return root.__wahupMobileTextEditor;
    var editor = document.createElement('div');
    editor.className = 'wahup-mobile-text-editor';
    editor.hidden = true;
    editor.innerHTML = '<div class="wahup-mobile-text-editor__bar">' +
      '<span class="wahup-mobile-text-editor__label">Edit text</span>' +
      '<button type="button" class="wahup-mobile-text-editor__clear" aria-label="Clear text">×</button>' +
      '<button type="button" class="wahup-mobile-text-editor__done">Done</button>' +
      '</div>' +
      '<input type="text" class="wahup-mobile-text-editor__input" autocomplete="off" autocorrect="off" autocapitalize="off" enterkeyhint="done" spellcheck="false">';
    root.appendChild(editor);

    var dockInput = editor.querySelector('.wahup-mobile-text-editor__input');
    var clear = editor.querySelector('.wahup-mobile-text-editor__clear');
    var done = editor.querySelector('.wahup-mobile-text-editor__done');

    editor.__wahupSyncToSource = function () {
      var source = editor.__wahupSourceInput;
      if (!source || !root.contains(source)) return;
      if (source.value !== dockInput.value) {
        source.value = dockInput.value;
        source.dispatchEvent(new Event('input', { bubbles: true }));
      } else if (typeof root.__wahupCustomShirtRefresh === 'function') {
        root.__wahupCustomShirtRefresh();
      }
    };

    editor.__wahupClose = function () {
      editor.__wahupAllowBlur = true;
      var source = editor.__wahupSourceInput;
      if (source) {
        source.classList.remove('wahup-mobile-edit-source-active');
        source.removeAttribute('readonly');
        source.removeAttribute('aria-readonly');
      }
      editor.__wahupSourceInput = null;
      root.classList.remove('has-mobile-text-editor');
      document.documentElement.classList.remove('wahup-mobile-text-editor-open');
      root.style.removeProperty('--wahup-mobile-visible-height');
      root.style.removeProperty('--wahup-mobile-keyboard-inset');
      root.style.removeProperty('--wahup-mobile-editor-height');
      root.style.removeProperty('--wahup-mobile-preview-top');
      root.style.removeProperty('--wahup-mobile-preview-max');
      setMobilePreviewPortal(root, false);
      restoreMobileTextEditorState(editor);
      restorePreviewZoomState(root, editor.__wahupRestorePreviewZoom || root.__wahupPreviewZoom);
      window.clearTimeout(editor.__wahupHideTimer);
      editor.classList.remove('is-open');
      editor.classList.add('is-closing');
      editor.__wahupHideTimer = window.setTimeout(function () {
        editor.hidden = true;
        editor.classList.remove('is-closing');
      }, 900);
      try { dockInput.blur(); } catch (error) {}
      window.setTimeout(function () { editor.__wahupAllowBlur = false; }, 920);
    };

    dockInput.addEventListener('input', editor.__wahupSyncToSource);
    dockInput.addEventListener('blur', function () {
      if (editor.__wahupAllowBlur || editor.hidden || !editor.classList.contains('is-open')) return;
      window.setTimeout(function () {
        if (editor.__wahupAllowBlur || editor.hidden || !editor.classList.contains('is-open')) return;
        try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
        try { dockInput.setSelectionRange(dockInput.value.length, dockInput.value.length); } catch (error) {}
      }, 0);
      window.setTimeout(function () {
        if (editor.__wahupAllowBlur || editor.hidden || !editor.classList.contains('is-open')) return;
        try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
      }, 120);
    });
    dockInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        editor.__wahupSyncToSource();
        window.setTimeout(function () {
          if (editor.hidden || !editor.classList.contains('is-open')) return;
          try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
        }, 0);
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        editor.__wahupSyncToSource();
      }
    });
    clear.addEventListener('click', function () {
      dockInput.value = '';
      editor.__wahupSyncToSource();
      trackEvent(root, 'custom_shirt_text_clear', {
        field_type: editor.__wahupSourceInput && editor.__wahupSourceInput.getAttribute('data-layer-id') ? 'layer_text' : 'slot_text',
        slot_id: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-slot-id') || '') : '',
        layer_id: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-layer-id') || '') : '',
        slot_label: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-slot-label') || '') : '',
        source: 'mobile_dock'
      });
      try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
      try { dockInput.setSelectionRange(0, 0); } catch (error) {}
    });
    done.addEventListener('click', function () {
      editor.__wahupSyncToSource();
      trackEvent(root, 'custom_shirt_text_done', {
        field_type: editor.__wahupSourceInput && editor.__wahupSourceInput.getAttribute('data-layer-id') ? 'layer_text' : 'slot_text',
        slot_id: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-slot-id') || '') : '',
        layer_id: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-layer-id') || '') : '',
        slot_label: editor.__wahupSourceInput ? (editor.__wahupSourceInput.getAttribute('data-slot-label') || '') : '',
        text_length: String(dockInput.value || '').length,
        source: 'mobile_dock'
      });
      editor.__wahupClose();
    });

    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        if (editor.hidden || !editor.classList.contains('is-open')) return;
        if (editor.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
      }, true);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { positionMobileTextEditor(editor); });
      window.visualViewport.addEventListener('scroll', function () { positionMobileTextEditor(editor); });
    }
    window.addEventListener('resize', function () { positionMobileTextEditor(editor); });

    root.__wahupMobileTextEditor = editor;
    root.__wahupMobileTextEditorClose = editor.__wahupClose;
    return editor;
  }

  function openMobileTextEditor(root, sourceInput) {
    if (!root || !sourceInput || !isMobileTextEditorMode()) return false;
    var editor = ensureMobileTextEditor(root);
    var dockInput = editor.querySelector('.wahup-mobile-text-editor__input');
    var label = editor.querySelector('.wahup-mobile-text-editor__label');
    var wasEditorOpen = editor.classList.contains('is-open') && !editor.hidden;
    if (!wasEditorOpen) {
      editor.__wahupRestorePreviewZoom = {
        active: !!(root.__wahupPreviewZoom && root.__wahupPreviewZoom.active),
        scale: root.__wahupPreviewZoom && root.__wahupPreviewZoom.scale ? root.__wahupPreviewZoom.scale : 1,
        panX: root.__wahupPreviewZoom && root.__wahupPreviewZoom.panX ? root.__wahupPreviewZoom.panX : 0,
        panY: root.__wahupPreviewZoom && root.__wahupPreviewZoom.panY ? root.__wahupPreviewZoom.panY : 0
      };
    }
    if (editor.__wahupSourceInput && editor.__wahupSourceInput !== sourceInput) {
      editor.__wahupSourceInput.classList.remove('wahup-mobile-edit-source-active');
    }
    editor.__wahupSourceInput = sourceInput;
    sourceInput.classList.add('wahup-mobile-edit-source-active');
    sourceInput.setAttribute('readonly', 'readonly');
    sourceInput.setAttribute('aria-readonly', 'true');
    label.textContent = sourceInput.getAttribute('data-slot-label') || sourceInput.getAttribute('placeholder') || 'Edit text';
    dockInput.value = sourceInput.value || '';
    dockInput.placeholder = sourceInput.getAttribute('placeholder') || '';
    var maxLength = sourceInput.getAttribute('maxlength');
    if (maxLength) dockInput.setAttribute('maxlength', maxLength);
    else dockInput.removeAttribute('maxlength');
    window.clearTimeout(editor.__wahupHideTimer);
    editor.hidden = false;
    editor.classList.remove('is-closing');
    editor.classList.add('is-open');
    captureMobileTextEditorState(root, editor);
    root.classList.add('has-mobile-text-editor');
    document.documentElement.classList.add('wahup-mobile-text-editor-open');
    setMobilePreviewPortal(root, true);
    var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
    if (dialog) dialog.scrollTop = 0;
    positionMobileTextEditor(editor);
    setPreviewZoom(root, true);
    try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
    try { dockInput.setSelectionRange(dockInput.value.length, dockInput.value.length); } catch (error) {}
    trackEvent(root, 'custom_shirt_text_dock_open', {
      field_type: sourceInput.getAttribute('data-layer-id') ? 'layer_text' : 'slot_text',
      slot_id: sourceInput.getAttribute('data-slot-id') || '',
      layer_id: sourceInput.getAttribute('data-layer-id') || '',
      slot_label: sourceInput.getAttribute('data-slot-label') || '',
      text_length: String(sourceInput.value || '').length,
      source: 'mobile'
    });
    window.setTimeout(function () {
      if (dialog) dialog.scrollTop = 0;
      positionMobileTextEditor(editor);
      setPreviewZoom(root, true);
      try { dockInput.focus({ preventScroll: true }); } catch (error) { dockInput.focus(); }
      try { dockInput.setSelectionRange(dockInput.value.length, dockInput.value.length); } catch (error) {}
    }, 0);
    return true;
  }

  function bindMobileTextFields(root) {
    if (!root || root.__wahupMobileTextBound) return;
    root.__wahupMobileTextBound = true;
    function focusSourceInput(sourceInput) {
      if (!sourceInput || sourceInput.disabled) return;
      sourceInput.removeAttribute('readonly');
      sourceInput.removeAttribute('aria-readonly');
      try { sourceInput.focus({ preventScroll: true }); } catch (error) { sourceInput.focus(); }
      try {
        var end = sourceInput.value.length;
        sourceInput.setSelectionRange(end, end);
      } catch (error) {}
    }
    function sourceFromEditButton(event) {
      var button = event.target && event.target.closest && event.target.closest('[data-mobile-text-edit]');
      if (!button || !root.contains(button)) return null;
      var wrap = button.closest('.wahup-custom-shirt-text-input-wrap');
      return wrap ? wrap.querySelector(textSourceSelector()) : null;
    }
    function intercept(event) {
      var sourceInput = sourceFromEditButton(event);
      if (!isMobileTextEditorMode()) {
        if (!sourceInput) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        focusSourceInput(sourceInput);
        return;
      }
      if (!sourceInput) {
        var directInput = event.target && event.target.closest && event.target.closest(textSourceSelector());
        if (!directInput || !root.contains(directInput)) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        try { directInput.blur(); } catch (error) {}
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      try { sourceInput.blur(); } catch (error) {}
      openMobileTextEditor(root, sourceInput);
    }
    ['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'touchend', 'click', 'focusin'].forEach(function (eventName) {
      root.addEventListener(eventName, intercept, true);
    });
    root.addEventListener('change', function () {
      if (!isMobileTextEditorMode() && typeof root.__wahupMobileTextEditorClose === 'function') root.__wahupMobileTextEditorClose();
    }, true);
  }

  function bindPopupScroll(root) {
    if (!root || root.__wahupScrollBound) return;
    root.__wahupScrollBound = true;
    var activeTextControl = null;
    var keepFocusUntil = 0;
    var suppressRefocusUntil = 0;
    function isEditableTextControl(node) {
      return !!(node && node.matches && node.matches('input[type="text"], input:not([type]), textarea'));
    }
    function rememberTextControl(control) {
      if (!isEditableTextControl(control)) return;
      activeTextControl = control;
      keepFocusUntil = Date.now() + 30000;
    }
    function restoreTextFocus() {
      if (!activeTextControl || activeTextControl.disabled || !root.contains(activeTextControl)) return;
      if (Date.now() > keepFocusUntil || Date.now() < suppressRefocusUntil || root.hidden) return;
      if (document.activeElement === activeTextControl) return;
      if (document.activeElement && root.contains(document.activeElement) && /^(INPUT|TEXTAREA|SELECT|BUTTON)$/i.test(document.activeElement.tagName)) return;
      try { activeTextControl.focus({ preventScroll: true }); } catch (error) { activeTextControl.focus(); }
    }
    function focusControl(event) {
      if (isMobileTextEditorMode()) return;
      var control = event.target && event.target.closest && event.target.closest('input[type="text"], input:not([type]), textarea, select');
      if (!control || !root.contains(control)) return;
      if (control.disabled) return;
      rememberTextControl(control);
      window.setTimeout(function () {
        try { control.focus({ preventScroll: true }); } catch (error) { control.focus(); }
      }, 0);
    }
    root.addEventListener('focusin', function (event) {
      if (isMobileTextEditorMode()) return;
      rememberTextControl(event.target);
    }, true);
    root.addEventListener('input', function (event) {
      if (isMobileTextEditorMode()) return;
      rememberTextControl(event.target);
      window.setTimeout(restoreTextFocus, 0);
      window.setTimeout(restoreTextFocus, 120);
      window.setTimeout(restoreTextFocus, 320);
    }, true);
    root.addEventListener('focusout', function (event) {
      if (isMobileTextEditorMode()) return;
      if (!isEditableTextControl(event.target)) return;
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      window.setTimeout(restoreTextFocus, 0);
      window.setTimeout(restoreTextFocus, 120);
      window.setTimeout(restoreTextFocus, 320);
    }, true);
    root.addEventListener('pointerdown', function (event) {
      var editable = event.target && event.target.closest && event.target.closest('input[type="text"], input:not([type]), textarea');
      if (editable) return;
      var intentionalControl = event.target && event.target.closest && event.target.closest('button, select, .wahup-custom-shirt-color, [data-custom-shirt-close], .wahup-custom-shirt-submit, .wahup-custom-shirt-checkout');
      if (intentionalControl) {
        suppressRefocusUntil = Date.now() + 1500;
        keepFocusUntil = 0;
        activeTextControl = null;
      }
    }, true);
    ['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'touchend', 'click'].forEach(function (eventName) {
      root.addEventListener(eventName, focusControl, true);
    });
    root.addEventListener('wheel', function (event) {
      var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
      if (!dialog || root.hidden) return;
      if (!dialog.contains(event.target)) {
        event.preventDefault();
        return;
      }
      var colorScroll = event.target.closest('.wahup-custom-shirt-colors');
      if (colorScroll && colorScroll.scrollWidth > colorScroll.clientWidth) {
        var colorBefore = colorScroll.scrollLeft;
        colorScroll.scrollLeft += Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        if (colorScroll.scrollLeft !== colorBefore) {
          event.preventDefault();
          return;
        }
      }
      var scrollEl = dialog;
      var before = scrollEl.scrollTop;
      scrollEl.scrollTop += event.deltaY;
      if (scrollEl.scrollTop !== before) event.preventDefault();
    }, { passive: false });
    root.addEventListener('touchmove', function (event) {
      var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
      if (event.target && event.target.closest && event.target.closest('input, textarea, select, button, label')) return;
      if (!dialog || root.hidden || dialog.contains(event.target)) return;
      event.preventDefault();
    }, { passive: false });
  }

  function bindColorListGesture(root, colorOptions) {
    if (!root || !colorOptions || colorOptions.__wahupGestureBound) return;
    colorOptions.__wahupGestureBound = true;
    colorOptions.setAttribute('data-gesture-bound', '1');
    var gesture = null;
    function clearGestureSoon() {
      window.setTimeout(function () {
        colorOptions.classList.remove('is-gesture-scrolling');
        if (gesture) gesture.mode = '';
      }, 80);
    }
    colorOptions.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
      gesture = {
        startX: touch.clientX,
        startY: touch.clientY,
        lastX: touch.clientX,
        lastY: touch.clientY,
        mode: '',
        dialog: dialog,
        dialogTop: dialog ? dialog.scrollTop : 0,
        colorLeft: colorOptions.scrollLeft || 0
      };
    }, { passive: true });
    colorOptions.addEventListener('touchmove', function (event) {
      if (!gesture || !event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      var dx = touch.clientX - gesture.startX;
      var dy = touch.clientY - gesture.startY;
      if (!gesture.mode && Math.max(Math.abs(dx), Math.abs(dy)) > 7) {
        gesture.mode = Math.abs(dy) > Math.abs(dx) ? 'vertical' : 'horizontal';
        colorOptions.classList.add('is-gesture-scrolling');
      }
      if (gesture.mode === 'vertical' && gesture.dialog) {
        gesture.dialog.scrollTop = gesture.dialogTop - dy;
        event.preventDefault();
      } else if (gesture.mode === 'horizontal') {
        colorOptions.scrollLeft = gesture.colorLeft - dx;
        event.preventDefault();
      }
      gesture.lastX = touch.clientX;
      gesture.lastY = touch.clientY;
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (eventName) {
      colorOptions.addEventListener(eventName, clearGestureSoon, { passive: true });
    });
    colorOptions.addEventListener('click', function (event) {
      if (gesture && gesture.mode) {
        event.preventDefault();
        event.stopPropagation();
      }
      clearGestureSoon();
    }, true);
  }

  function ensureColorScrollerNav(root, colorOptions) {
    if (!root || !colorOptions || colorOptions.__wahupNavBound) return;
    colorOptions.__wahupNavBound = true;
    var parent = colorOptions.parentElement;
    if (!parent) return;
    var shell = parent.classList && parent.classList.contains('wahup-custom-shirt-color-nav') ? parent : null;
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'wahup-custom-shirt-color-nav';
      parent.insertBefore(shell, colorOptions);
      shell.appendChild(colorOptions);
    }
    function makeButton(direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'wahup-custom-shirt-color-nav__button wahup-custom-shirt-color-nav__button--' + direction;
      button.setAttribute('aria-label', direction === 'left' ? 'Scroll colors left' : 'Scroll colors right');
      button.setAttribute('data-color-scroll-' + direction, '1');
      button.innerHTML = direction === 'left' ? '&#8249;' : '&#8250;';
      return button;
    }
    var left = shell.querySelector('[data-color-scroll-left]') || makeButton('left');
    var right = shell.querySelector('[data-color-scroll-right]') || makeButton('right');
    if (!left.parentElement) shell.appendChild(left);
    if (!right.parentElement) shell.appendChild(right);

    function updateButtons() {
      var max = Math.max(0, colorOptions.scrollWidth - colorOptions.clientWidth);
      var canScroll = max > 4;
      shell.classList.toggle('has-scroll', canScroll);
      left.disabled = !canScroll || colorOptions.scrollLeft <= 4;
      right.disabled = !canScroll || colorOptions.scrollLeft >= max - 4;
    }
    function scrollByPage(direction) {
      var amount = Math.max(120, Math.round(colorOptions.clientWidth * 0.72)) * (direction === 'left' ? -1 : 1);
      if (typeof colorOptions.scrollBy === 'function') {
        colorOptions.scrollBy({ left: amount, behavior: 'smooth' });
      } else {
        colorOptions.scrollLeft += amount;
      }
      window.setTimeout(updateButtons, 260);
      window.setTimeout(updateButtons, 520);
    }
    left.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollByPage('left');
      trackEvent(root, 'custom_shirt_color_scroll', { direction:'left', source:'arrow' });
    });
    right.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      scrollByPage('right');
      trackEvent(root, 'custom_shirt_color_scroll', { direction:'right', source:'arrow' });
    });
    colorOptions.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    window.setTimeout(updateButtons, 0);
    window.setTimeout(updateButtons, 350);
  }

  function bindProgressNavigation(root) {
    var progress = root && root.querySelector('.wahup-custom-shirt-progress');
    if (!progress || progress.__wahupProgressBound) return;
    progress.__wahupProgressBound = true;
    var items = Array.prototype.slice.call(progress.querySelectorAll('span'));
    if (!items.length) return;

    function itemKey(item, index) {
      var explicit = item.getAttribute('data-step') || item.getAttribute('data-target');
      if (explicit) return String(explicit).toLowerCase();
      var text = String(item.textContent || '').toLowerCase();
      if (text.indexOf('type') !== -1 || index === 0) return 'type';
      if (text.indexOf('color') !== -1 || text.indexOf('colour') !== -1 || index === 1) return 'color';
      if (text.indexOf('size') !== -1 || index === 2) return 'size';
      if (text.indexOf('cart') !== -1 || index === 3) return 'cart';
      return '';
    }

    function cardForKey(key) {
      if (key === 'type') {
        var textFields = root.querySelector('[data-text-fields]');
        return textFields && textFields.closest('.wahup-custom-shirt-step-card');
      }
      if (key === 'color') {
        var colors = root.querySelector('[data-color-options], [data-inline-color-options]');
        return colors && colors.closest('.wahup-custom-shirt-step-card');
      }
      if (key === 'size') {
        var size = root.querySelector('select[name="size"]');
        return size && size.closest('.wahup-custom-shirt-step-card');
      }
      if (key === 'cart') {
        return root.querySelector('.wahup-custom-shirt-actions');
      }
      return null;
    }

    function setActive(activeItem) {
      items.forEach(function (item) { item.classList.toggle('is-active', item === activeItem); });
    }

    function scrollToTarget(target) {
      if (!target) return;
      var dialog = root.querySelector('[data-custom-shirt-dialog], .wahup-custom-shirt-popup__dialog');
      if (!dialog) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var dialogRect = dialog.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var offset = targetRect.top - dialogRect.top + dialog.scrollTop - 12;
      dialog.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
    }

    items.forEach(function (item, index) {
      var key = itemKey(item, index);
      if (!key) return;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('data-wahup-progress-step', key);
      function activate(event) {
        event.preventDefault();
        var target = cardForKey(key);
        if (!target) return;
        setActive(item);
        trackEvent(root, 'custom_shirt_step_click', { step:key });
        scrollToTarget(target);
      }
      item.addEventListener('click', activate);
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        activate(event);
      });
    });
  }

  function initBuilder(root) {
    var data = document.getElementById('wahup-custom-shirt-template-data');
    if (!data) return;
    var templates = [];
    try { templates = JSON.parse(data.textContent || '[]'); } catch (error) { templates = []; }
    var fontData = document.getElementById('wahup-custom-shirt-font-data');
    try { window.__wahupDesignFonts = fontData ? JSON.parse(fontData.textContent || '[]') : []; } catch (error) { window.__wahupDesignFonts = []; }
    var picker = root.querySelector('[data-template-picker]');
    var builder = root.querySelector('[data-template-builder], [data-inline-shirt-builder]');
    var title = root.querySelector('[data-builder-title]');
    var productName = root.querySelector('[data-builder-product-name]');
    var subtitle = root.querySelector('[data-builder-subtitle]');
    var colorOptions = root.querySelector('[data-color-options], [data-inline-color-options]');
    var textFields = root.querySelector('[data-text-fields]');
    var form = root.querySelector('[data-shirt-form], [data-inline-shirt-form]');
    var status = root.querySelector('[data-shirt-status]');
    var activeTemplate = null;
    var activeMockup = null;
    if (form) { form.removeAttribute('onsubmit'); form.onsubmit = null; }
    bindProgressNavigation(root);
    bindColorListGesture(root, colorOptions);
    ensureColorScrollerNav(root, colorOptions);
    root.__wahupCustomShirtRefresh = function () {
      if (activeTemplate && activeMockup) renderPreview(activeTemplate, activeMockup, form, root);
    };

    function ensurePreviewCloseButton() {
      var close = root.querySelector('.wahup-custom-shirt-popup__close');
      var dialog = root.querySelector('.wahup-custom-shirt-popup__dialog');
      if (!close || !dialog || close.parentNode === dialog) return;
      dialog.insertBefore(close, dialog.firstChild);
    }

    function colorFlashBadge() {
      var preview = root.querySelector('.wahup-custom-shirt-preview');
      if (!preview) return null;
      var badge = preview.querySelector('.wahup-custom-shirt-color-flash-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'wahup-custom-shirt-color-flash-badge';
        badge.setAttribute('aria-live', 'polite');
        preview.appendChild(badge);
      }
      return badge;
    }

    function flashActiveColorName() {
      if (!activeMockup) return;
      var badge = colorFlashBadge();
      if (!badge) return;
      badge.textContent = activeMockup.color_name || 'Color';
      badge.classList.remove('is-flashing');
      void badge.offsetWidth;
      badge.classList.add('is-flashing');
    }

    function selectMockupById(id, source) {
      if (!activeTemplate) return;
      var previousMockupId = activeMockup && activeMockup.id;
      activeMockup = (activeTemplate.mockups || []).find(function (mockup) { return String(mockup.id) === String(id); }) || activeMockup;
      if (!activeMockup) return;
      root.__wahupActiveTemplate = activeTemplate;
      root.__wahupActiveMockup = activeMockup;
      if (form) form.setAttribute('data-active-mockup-id', String(activeMockup.id));
      if (colorOptions) {
        colorOptions.querySelectorAll('[data-mockup-id]').forEach(function (item) {
          var isActive = String(activeMockup.id) === item.getAttribute('data-mockup-id');
          item.classList.toggle('is-active', isActive);
          var itemRadio = item.querySelector('input[name="mockup_id"]');
          if (itemRadio) itemRadio.checked = isActive;
        });
      }
      if (textFields) renderTextFields(textFields, activeTemplate, activeMockup, collectFieldValues(form), root);
      root.__wahupCustomShirtRefresh();
      if (String(previousMockupId || '') !== String(activeMockup.id || '')) flashActiveColorName();
      if (String(previousMockupId || '') !== String(activeMockup.id || '') || source) {
        trackEvent(root, 'custom_shirt_color_select', Object.assign(
          {},
          templateTracking(activeTemplate),
          mockupTracking(activeMockup),
          { source:source || 'color_option' }
        ));
      }
    }

    function ensurePreviewMockupNav() {
      var preview = root.querySelector('.wahup-custom-shirt-preview');
      if (!preview || preview.__wahupMockupNavBound) return;
      preview.__wahupMockupNavBound = true;
      [
        { direction:'prev', label:'Previous shirt color', icon:'‹' },
        { direction:'next', label:'Next shirt color', icon:'›' }
      ].forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'wahup-custom-shirt-preview-nav wahup-custom-shirt-preview-nav--' + item.direction;
        button.setAttribute('aria-label', item.label);
        button.setAttribute('data-preview-mockup-nav', item.direction);
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var mockups = (activeTemplate && activeTemplate.mockups) || [];
          if (mockups.length < 2 || !activeMockup) return;
          var index = mockups.findIndex(function (mockup) { return String(mockup.id) === String(activeMockup.id); });
          if (index < 0) index = 0;
          var nextIndex = item.direction === 'prev'
            ? (index - 1 + mockups.length) % mockups.length
            : (index + 1) % mockups.length;
          if (mockups[nextIndex]) selectMockupById(mockups[nextIndex].id, 'preview_arrow_' + item.direction);
        });
        preview.appendChild(button);
      });
    }

    function requestSizeSelection(checkout) {
      if (!form) return false;
      var sizeEl = form.querySelector('select[name="size"]');
      if (!sizeEl) return false;
      var options = Array.prototype.slice.call(sizeEl.options || []);
      if (!options.length) return false;
      var modal = root.querySelector('[data-size-modal]');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'wahup-custom-shirt-size-modal';
        modal.setAttribute('data-size-modal', '1');
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.innerHTML =
          '<div class="wahup-custom-shirt-size-modal__panel">' +
            '<div class="wahup-custom-shirt-size-modal__head">' +
              '<p class="wahup-custom-shirt-size-modal__title">Choose size</p>' +
              '<button type="button" class="wahup-custom-shirt-size-modal__close" data-size-close aria-label="Close size picker">×</button>' +
            '</div>' +
            '<div class="wahup-custom-shirt-size-modal__options" data-size-options></div>' +
          '</div>';
        root.appendChild(modal);
        modal.addEventListener('click', function (event) {
          if (event.target === modal || event.target.closest('[data-size-close]')) {
            modal.hidden = true;
            trackEvent(root, 'custom_shirt_size_modal_close', { source:'dismiss' });
          }
        });
      }
      var optionsWrap = modal.querySelector('[data-size-options]');
      if (optionsWrap) {
        optionsWrap.innerHTML = options.map(function (option) {
          var active = option.value === sizeEl.value ? ' is-active' : '';
          return '<button type="button" class="wahup-custom-shirt-size-modal__option' + active + '" data-size-value="' + escapeHtml(option.value) + '">' + escapeHtml(option.text || option.value) + '</button>';
        }).join('');
        optionsWrap.querySelectorAll('[data-size-value]').forEach(function (button) {
          button.addEventListener('click', function () {
            sizeEl.value = button.getAttribute('data-size-value') || '';
            sizeEl.dispatchEvent(new Event('change', { bubbles:true }));
            modal.hidden = true;
            trackEvent(root, 'custom_shirt_size_modal_confirm', { size:sizeEl.value || '', checkout:!!checkout });
            form.setAttribute('data-size-confirmed', '1');
            var submitButton = form.querySelector(checkout ? '.wahup-custom-shirt-checkout' : '.wahup-custom-shirt-submit');
            if (submitButton) submitButton.click();
            else if (form.requestSubmit) form.requestSubmit();
          });
        });
      }
      modal.hidden = false;
      trackEvent(root, 'custom_shirt_size_modal_open', { checkout:!!checkout, current_size:sizeEl.value || '' });
      return true;
    }

    function selectTemplate(template, source) {
      if (typeof root.__wahupMobileTextEditorClose === 'function') root.__wahupMobileTextEditorClose();
      var previousMockupId = activeMockup && activeMockup.id;
      var previousColorName = activeMockup && activeMockup.color_name;
      activeTemplate = template;
      activeMockup = (template.mockups || []).find(function (mockup) { return String(mockup.id) === String(previousMockupId); }) ||
        (template.mockups || []).find(function (mockup) { return previousColorName && String(mockup.color_name || '').toLowerCase() === String(previousColorName).toLowerCase(); }) ||
        (template.mockups || []).find(function (mockup) { return mockup.is_default; }) ||
        (template.mockups || [])[0] || null;
      root.__wahupActiveTemplate = activeTemplate;
      root.__wahupActiveMockup = activeMockup;
      if (title) title.textContent = template.name;
      if (productName) productName.textContent = template.name || '';
      if (form) form.setAttribute('data-template-id', template.id);
      if (form && activeMockup) form.setAttribute('data-active-mockup-id', String(activeMockup.id));
      if (subtitle) subtitle.textContent = (template.product_type || '').replace(/_/g, ' ') + ' · ' + (template.mockups || []).length + ' colors';
      if (colorOptions) {
        colorOptions.innerHTML = (template.mockups || []).map(function (mockup, index) {
          var active = activeMockup && String(activeMockup.id) === String(mockup.id) ? ' is-active' : '';
          return '<label class="wahup-custom-shirt-color' + active + '" data-mockup-id="' + mockup.id + '">' +
            '<input type="radio" name="mockup_id" value="' + mockup.id + '" ' + (active ? 'checked' : '') + '>' +
            (mockup.image_url ? '<img src="' + mockup.image_url + '" alt="" loading="lazy" decoding="async">' : '') +
            '<span>' + escapeHtml(mockup.color_name || 'Color') + '</span></label>';
        }).join('');
        ensureColorScrollerNav(root, colorOptions);
        colorOptions.querySelectorAll('[data-mockup-id]').forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            selectMockupById(button.getAttribute('data-mockup-id'), 'color_option');
          });
        });
      }
      ensurePreviewMockupNav();
      ensurePreviewCloseButton();
      colorFlashBadge();
      if (textFields) renderTextFields(textFields, template, activeMockup, collectFieldValues(form), root);
      if (picker) picker.hidden = true;
      if (builder && builder.hasAttribute('data-template-builder')) builder.hidden = false;
      root.querySelectorAll('[data-mockup-id]').forEach(function (button) {
        button.classList.toggle('is-active', activeMockup && String(activeMockup.id) === button.getAttribute('data-mockup-id'));
      });
      root.__wahupCustomShirtRefresh();
      trackEvent(root, 'custom_shirt_template_select', Object.assign(
        {},
        templateTracking(activeTemplate),
        mockupTracking(activeMockup),
        { source:source || 'initial' }
      ));
    }

    root.querySelectorAll('[data-template-id]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-template-id');
        var template = templates.find(function (item) { return String(item.id) === String(id); });
        if (template) selectTemplate(template, 'template_picker');
      });
    });

    root.querySelector('[data-template-back]')?.addEventListener('click', function () {
      if (builder) builder.hidden = true;
      if (picker) picker.hidden = false;
    });

    colorOptions?.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mockup-id]');
      if (!button || !activeTemplate) return;
      selectMockupById(button.getAttribute('data-mockup-id'), 'color_option');
    });

    form?.addEventListener('input', function (event) {
      root.__wahupCustomShirtRefresh();
      var target = event.target;
      if (target && target.matches && target.matches('[data-slot-id], [data-layer-id]')) {
        var fieldKey = target.getAttribute('data-layer-id') || target.getAttribute('data-slot-id') || '';
        var now = Date.now();
        root.__wahupLastTextTrack = root.__wahupLastTextTrack || {};
        if (!root.__wahupLastTextTrack[fieldKey] || now - root.__wahupLastTextTrack[fieldKey] > 1800) {
          root.__wahupLastTextTrack[fieldKey] = now;
          trackEvent(root, 'custom_shirt_text_edit', Object.assign(
            {},
            templateTracking(activeTemplate),
            mockupTracking(activeMockup),
            inputTracking(target)
          ));
        }
      }
    });

    form?.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('select[name="size"]') && activeMockup) {
        var keepMockupId = activeMockup.id;
        trackEvent(root, 'custom_shirt_size_select', Object.assign(
          {},
          templateTracking(activeTemplate),
          mockupTracking(activeMockup),
          { size:event.target.value || '' }
        ));
        window.setTimeout(function () { selectMockupById(keepMockupId, 'size_change_keep_color'); }, 0);
      }
    }, true);

    form?.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!activeTemplate || !activeMockup) return;
      var submitter = event.submitter;
      var checkout = submitter && submitter.getAttribute('data-checkout') === '1';
      if (!form.getAttribute('data-size-confirmed') && requestSizeSelection(checkout)) return;
      if (status) status.textContent = 'Saving preview...';
      var fields = editableFields(activeTemplate, activeMockup, root);
      var texts = fields.map(function (field) {
        if (field.field_type === 'image_layer') {
          return {
            type: 'image',
            field_type: 'image_layer',
            slot_id: '',
            layer_id: field.layer_id || '',
            label: field.label,
            image_url: fieldImageValue(field, form, root),
            text: ''
          };
        }
        return { slot_id: field.id, layer_id: field.layer_id || '', label: field.label, text: fieldText(field, form) };
      });
      var textCount = texts.filter(function (item) { return item && item.text; }).length;
      var imageCount = texts.filter(function (item) { return item && item.image_url; }).length;
      var sizeEl = form.querySelector('select[name="size"]');
      var size = sizeEl ? sizeEl.value : '';
      var customPreviewUrl = '';
      var preparedDraftId = '';
      var preparedVariantId = '';
      form.removeAttribute('data-size-confirmed');
      form.setAttribute('data-busy', '1');
      trackEvent(root, checkout ? 'custom_shirt_checkout_click' : 'custom_shirt_add_to_cart_click', Object.assign(
        {},
        templateTracking(activeTemplate),
        mockupTracking(activeMockup),
        { size:size, text_count:textCount, image_count:imageCount }
      ));
      fetch(apiBase(root) + 'preview/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        mode: 'cors',
        body: JSON.stringify({ template_id: activeTemplate.id, mockup_id: activeMockup.id, texts: texts, size: size })
      })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.ok) throw new Error(payload.error || 'Preview failed');
          customPreviewUrl = payload.preview_image_url || payload.preview_url || payload.image_url || '';
          trackEvent(root, 'custom_shirt_preview_success', Object.assign(
            {},
            templateTracking(activeTemplate),
            mockupTracking(activeMockup),
            { size:size, draft_id:payload.draft_id || '' }
          ));
          if (status) status.textContent = 'Preparing Shopify cart item...';
          return fetch(apiBase(root) + 'create-product/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            mode: 'cors',
            body: JSON.stringify({ draft_id: payload.draft_id, quantity: 1, size: size })
          });
        })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.ok) throw new Error(payload.error || 'Could not prepare Shopify item.');
          if (!payload.cart_add || !payload.cart_add.id) throw new Error('Missing Shopify variant for this template.');
          preparedDraftId = payload.draft_id || '';
          preparedVariantId = payload.cart_add.id || payload.shopify_variant_id || '';
          trackEvent(root, 'custom_shirt_product_ready', Object.assign(
            {},
            templateTracking(activeTemplate),
            mockupTracking(activeMockup),
            { size:size, variant_id:payload.cart_add.id }
          ));
          payload.cart_add.properties = customCartProperties(customPreviewUrl || (payload.cart_add.properties && payload.cart_add.properties['Custom preview']) || '', texts, payload.cart_add.properties, activeMockup);
          if (status) status.textContent = 'Adding to cart...';
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload.cart_add)
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Shopify cart add failed.');
          trackEvent(root, 'custom_shirt_cart_add_success', Object.assign(
            {},
            templateTracking(activeTemplate),
            mockupTracking(activeMockup),
            { size:size, destination:checkout ? 'checkout' : 'cart' }
          ));
          if (preparedDraftId) {
            return fetch(apiBase(root) + 'cart-added/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'omit',
              mode: 'cors',
              keepalive: true,
              body: JSON.stringify({ draft_id: preparedDraftId, variant_id: preparedVariantId, size: size })
            }).catch(function () { return null; });
          }
          return null;
        })
        .then(function () {
          if (status) status.textContent = checkout ? 'Opening checkout...' : 'Added to cart.';
          window.location.href = checkout ? '/checkout' : '/cart';
        })
        .catch(function (error) {
          trackEvent(root, 'custom_shirt_error', Object.assign(
            {},
            templateTracking(activeTemplate),
            mockupTracking(activeMockup),
            { size:size, error_message:(error && error.message) || 'Could not create shirt.' }
          ));
          if (status) status.textContent = error.message || 'Could not create shirt.';
        })
        .finally(function () {
          form.removeAttribute('data-busy');
          form.removeAttribute('data-size-confirmed');
        });
    });

    if (builder && templates.length) selectTemplate(templates[0], 'initial');
    bindPopupScroll(root);
    bindMobileTextFields(root);
  }

  function preparePopupHtml(root, body, html) {
    body.innerHTML = html || fallbackHtml();
    body.querySelectorAll('img').forEach(function (image) { image.loading = image.loading || 'lazy'; image.decoding = 'async'; });
    try {
      initBuilder(root);
    } catch (error) {
      root.__wahupPopupInitError = error;
      if (window.console && console.error) console.error('[wahup-custom-shirt] initBuilder failed', error);
    }
  }

  function hasHydratedBuilder(root) {
    return !!(root && root.querySelector('[data-template-builder], [data-inline-shirt-builder], #wahup-custom-shirt-template-data'));
  }

  function loadPopup(root, options) {
    options = options || {};
    var body = root.querySelector('[data-custom-shirt-body]');
    if (!body) return Promise.reject(new Error('Missing popup body'));
    if (root.__wahupPopupLoading && root.__wahupPopupLoadPromise) return root.__wahupPopupLoadPromise;
    body.innerHTML = loadingHtml();
    root.__wahupPopupLoading = true;
    root.__wahupPopupLoadPromise = fetchPopupPayload(root, { attempts:options.attempts || 3, timeoutMs:options.timeoutMs || 8000 })
      .then(function (payload) {
        preparePopupHtml(root, body, payload && payload.html ? payload.html : '');
        if (!hasHydratedBuilder(root)) throw new Error('Missing custom shirt builder markup');
        root.__wahupPopupLoaded = true;
        if (!root.__wahupImpressionTracked) {
          root.__wahupImpressionTracked = true;
          trackEvent(root, 'custom_shirt_impression');
          trackEvent(root, 'custom_shirt_builder_loaded', {
            template_count: root.querySelectorAll('[data-template-id]').length || 1,
            source: root.matches && root.matches('[data-wahup-custom-shirt-inline-root]') ? 'product_page_inline' : 'popup'
          });
        }
        return true;
      })
      .catch(function (error) {
        root.__wahupPopupLoadError = error;
        root.__wahupPopupLoaded = false;
        body.innerHTML = fallbackHtml();
        trackEvent(root, 'custom_shirt_load_error', { error_message:(error && error.message) || 'Popup load failed' });
        throw error;
      })
      .finally(function () {
        root.__wahupPopupLoading = false;
        root.__wahupPopupLoadPromise = null;
      });
    return root.__wahupPopupLoadPromise;
  }

  function initInlineBuilders() {
    document.querySelectorAll('[data-wahup-custom-shirt-inline-root]').forEach(function (root) {
      if (root.__wahupInlineBooted) return;
      root.__wahupInlineBooted = true;
      loadPopup(root, { attempts:3, timeoutMs:10000 })
        .catch(function (error) {
          if (window.console && console.error) console.error('[wahup-custom-shirt] inline builder failed', error);
        });
    });
  }

  function initPopupLauncher() {
    var root = document.getElementById('wahup-custom-shirt-popup-root');
    if (!root) return;
    var launcher = ensureLauncher(root);
    if (launcher && !launcher.__wahupLoadBound) {
      launcher.__wahupLoadBound = true;
      launcher.addEventListener('click', function (event) {
        if (root.__wahupPopupLoaded) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        trackEvent(root, 'custom_shirt_launcher_click', { loaded:false });
        openPopup(root, root.__wahupPopupLoading ? 'launcher_loading' : 'launcher');
        loadPopup(root, { attempts:3, timeoutMs:8000 })
          .then(function () {
            if (!root.hidden) openPopup(root, 'launcher_loaded');
          })
          .catch(function () {
            if (root.hidden) launcher.hidden = false;
          });
      }, true);
    }
    root.classList.add('is-collapsed');
    root.querySelectorAll('[data-custom-shirt-close]').forEach(function (button) { button.addEventListener('click', function () { closePopup(root, 'close_button'); }); });
    var delay = parseInt(root.getAttribute('data-delay-ms') || '3000', 10);
    window.setTimeout(function () {
      afterPageSettled(function () {
        loadPopup(root, { attempts:3, timeoutMs:8000 })
          .then(function () { shakeLauncherBeforeOpen(root, function () { openPopup(root, 'auto_delay'); }); })
          .catch(function () {
            var launcher = ensureLauncher(root);
            if (launcher) launcher.hidden = false;
          });
      });
    }, Number.isFinite(delay) ? delay : 3000);
  }

  ready(function () {
    initInlineBuilders();
    initPopupLauncher();
  });
})();
